/******/ (function() { // webpackBootstrap
/******/ 	"use strict";

;// ./src/scripts/services/product-service.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// services/ProductService.js
/**
 * @class ProductService
 * @description Service class for handling product-related operations
 */
var ProductService = /*#__PURE__*/function () {
  function ProductService() {
    _classCallCheck(this, ProductService);
  }
  return _createClass(ProductService, [{
    key: "getProductsFromSessionStorage",
    value:
    /**
     * @method getProductsFromSessionStorage
     * @description Fetch products from session storage
     * @returns {Object[]} Array of product objects
     * @throws {Error} If no products are found in session storage
     */
    function getProductsFromSessionStorage() {
      var productsJson = localStorage.getItem('compare_products');
      if (!productsJson) {
        throw new Error('No products found in session storage');
      }
      return JSON.parse(productsJson);
    }

    /**
     * @method getProductInfo
     * @description Get product info for a single productId
     * @param {string} productId - The ID of the product
     * @returns {Promise<Object|null>} Product information object or null if fetch fails
     */
  }, {
    key: "getProductInfo",
    value: (function () {
      var _getProductInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(productId) {
        var _yield$Promise$all, _yield$Promise$all2, productResponse, comparisonResponse, productData, sectionsData, comparisonHTML, comparisonElement;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Promise.all([fetch("".concat(window.Shopify.routes.root, "products/").concat(productId, ".js")), fetch("".concat(window.Shopify.routes.root, "products/").concat(productId, "?sections=main-product-comparison"), {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              })]);
            case 3:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              productResponse = _yield$Promise$all2[0];
              comparisonResponse = _yield$Promise$all2[1];
              if (!(!productResponse.ok || !comparisonResponse.ok)) {
                _context.next = 9;
                break;
              }
              throw new Error("Failed to fetch data for productId ".concat(productId));
            case 9:
              _context.next = 11;
              return productResponse.json();
            case 11:
              productData = _context.sent;
              _context.next = 14;
              return comparisonResponse.json();
            case 14:
              sectionsData = _context.sent;
              // The sections data will include the HTML for our section
              comparisonHTML = new DOMParser().parseFromString(sectionsData['main-product-comparison'], 'text/html');
              comparisonElement = comparisonHTML.querySelector('.main-product-comparison');
              return _context.abrupt("return", {
                id: productData.id,
                vendor: productData.vendor,
                comparisonElement: comparisonElement
              });
            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
              return _context.abrupt("return", null);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 20]]);
      }));
      function getProductInfo(_x) {
        return _getProductInfo.apply(this, arguments);
      }
      return getProductInfo;
    }()
    /**
     * @method fetchProductInfo
     * @description Fetch product info for multiple productIds
     * @param {string[]} productIds - Array of product IDs
     * @returns {Promise<Object[]>} Array of product information objects
     */
    )
  }, {
    key: "fetchProductInfo",
    value: (function () {
      var _fetchProductInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(productIds) {
        var _this = this;
        var productInfoPromises, productsInfo;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              productInfoPromises = productIds.map(function (id) {
                return _this.getProductInfo(id);
              });
              _context2.next = 3;
              return Promise.all(productInfoPromises);
            case 3:
              productsInfo = _context2.sent;
              return _context2.abrupt("return", productsInfo.filter(Boolean));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function fetchProductInfo(_x2) {
        return _fetchProductInfo.apply(this, arguments);
      }
      return fetchProductInfo;
    }()
    /**
     * @method fetchRelatedProducts
     * @description Fetch related products for multiple productIds
     * @param {string[]} productIds - Array of product IDs
     * @returns {Promise<Object[]>} Array of related product objects
     */
    )
  }, {
    key: "fetchRelatedProducts",
    value: (function () {
      var _fetchRelatedProducts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(productIds) {
        var _this2 = this;
        var fetchPromises, results;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              fetchPromises = productIds.map(function (id) {
                return _this2.fetchRelatedProductsById(id);
              });
              _context3.next = 4;
              return Promise.all(fetchPromises);
            case 4:
              results = _context3.sent;
              return _context3.abrupt("return", this.mergeDuplicateProducts(results.flat()));
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);
              return _context3.abrupt("return", []);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 8]]);
      }));
      function fetchRelatedProducts(_x3) {
        return _fetchRelatedProducts.apply(this, arguments);
      }
      return fetchRelatedProducts;
    }()
    /**
     * @method fetchRelatedProductsById
     * @description Fetch related products for a single productId
     * @param {string} productId - The ID of the product
     * @returns {Promise<Object[]>} Array of related product objects
     */
    )
  }, {
    key: "fetchRelatedProductsById",
    value: (function () {
      var _fetchRelatedProductsById = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(productId) {
        var url, response, _yield$response$json, products;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              url = "".concat(window.Shopify.routes.root, "recommendations/products.json?product_id=").concat(productId, "&limit=4&intent=related");
              _context4.next = 4;
              return fetch(url);
            case 4:
              response = _context4.sent;
              if (response.ok) {
                _context4.next = 7;
                break;
              }
              throw new Error("HTTP error! status: ".concat(response.status, " for productId ").concat(productId));
            case 7:
              _context4.next = 9;
              return response.json();
            case 9:
              _yield$response$json = _context4.sent;
              products = _yield$response$json.products;
              return _context4.abrupt("return", products || []);
            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](0);
              console.error(_context4.t0);
              return _context4.abrupt("return", []);
            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 14]]);
      }));
      function fetchRelatedProductsById(_x4) {
        return _fetchRelatedProductsById.apply(this, arguments);
      }
      return fetchRelatedProductsById;
    }()
    /**
     * @method mergeDuplicateProducts
     * @description Remove duplicate products based on product ID
     * @param {Object[]} products - Array of product objects
     * @returns {Object[]} Array of unique product objects
     */
    )
  }, {
    key: "mergeDuplicateProducts",
    value: function mergeDuplicateProducts(products) {
      var uniqueProducts = [];
      var seenIds = new Set();
      var _iterator = _createForOfIteratorHelper(products),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var product = _step.value;
          if (!seenIds.has(product.id)) {
            seenIds.add(product.id);
            uniqueProducts.push(product);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return uniqueProducts;
    }

    /**
     * @method extractUniqueVendors
     * @description Extract unique vendors from a list of products
     * @param {Object[]} products - Array of product objects
     * @returns {string[]} Array of unique vendor names
     */
  }, {
    key: "extractUniqueVendors",
    value: function extractUniqueVendors(products) {
      return _toConsumableArray(new Set(products.map(function (product) {
        return product.vendor;
      })));
    }

    /**
     * @method filterNewVendors
     * @description Filter vendors not present in the existing vendor list
     * @param {string[]} allVendors - Array of all vendor names
     * @param {string[]} existingVendors - Array of existing vendor names
     * @returns {string[]} Array of new vendor names
     */
  }, {
    key: "filterNewVendors",
    value: function filterNewVendors(allVendors, existingVendors) {
      var existingVendorSet = new Set(existingVendors);
      return allVendors.filter(function (vendor) {
        return !existingVendorSet.has(vendor);
      });
    }
  }]);
}();
/* harmony default export */ var product_service = (ProductService);
;// ./src/scripts/components/getProductHighlights.js
function getProductHighlights_typeof(o) { "@babel/helpers - typeof"; return getProductHighlights_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, getProductHighlights_typeof(o); }
function getProductHighlights_toConsumableArray(r) { return getProductHighlights_arrayWithoutHoles(r) || getProductHighlights_iterableToArray(r) || getProductHighlights_unsupportedIterableToArray(r) || getProductHighlights_nonIterableSpread(); }
function getProductHighlights_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function getProductHighlights_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return getProductHighlights_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? getProductHighlights_arrayLikeToArray(r, a) : void 0; } }
function getProductHighlights_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function getProductHighlights_arrayWithoutHoles(r) { if (Array.isArray(r)) return getProductHighlights_arrayLikeToArray(r); }
function getProductHighlights_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function getProductHighlights_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function getProductHighlights_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, getProductHighlights_toPropertyKey(o.key), o); } }
function getProductHighlights_createClass(e, r, t) { return r && getProductHighlights_defineProperties(e.prototype, r), t && getProductHighlights_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = getProductHighlights_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function getProductHighlights_toPropertyKey(t) { var i = getProductHighlights_toPrimitive(t, "string"); return "symbol" == getProductHighlights_typeof(i) ? i : i + ""; }
function getProductHighlights_toPrimitive(t, r) { if ("object" != getProductHighlights_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != getProductHighlights_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class ProductHighlights
 * @description Manages the display of product highlights in a comparison modal
 */
var ProductHighlights = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {string} selector - CSS selector for the compare products modal
   */
  function ProductHighlights(selector, infoSelector) {
    getProductHighlights_classCallCheck(this, ProductHighlights);
    /**
     * @method productHighlightsHTMLTemplate
     * @description Generates HTML template for a single product highlight
     * @param {string} highlight_icon - URL of the highlight icon
     * @param {string} highlight_copy - Text description of the highlight
     * @param {string} id - Product ID
     * @returns {string} HTML string for the product highlight
     */
    _defineProperty(this, "productHighlightsHTMLTemplate", function (highlight_icon, highlight_copy, id) {
      return "\n    <div class=\"product-highlights ".concat(!highlight_icon && highlight_copy == undefined ? 'product-highlights--empty' : 'product-highlights--not-empty', "\" data-highlight-type=\"").concat(id, "\">\n      <div class=\"product-highlight ").concat(!highlight_icon && highlight_copy == undefined ? 'product-highlight--empty' : 'product-highlight--not-empty', "\" data-highlight-item=\"").concat(id, "\">\n        ").concat(highlight_icon ? "<img src=\"".concat(highlight_icon, "\" alt=\"\" class=\"product-highlight__icon\">") : '', "\n        ").concat(highlight_copy ? "<p class=\"product-highlight__copy\">".concat(highlight_copy.replace(/\+/g, ' '), "</p>") : '', "\n      </div>\n    </div>\n  ");
    });
    this.compareProductsModal = document.querySelector(selector);
    this.compareProductsInfo = document.querySelector(infoSelector);
  }

  /**
   * @method getProductHighlights
   * @description Extracts and renders product highlights
   * @param {HTMLElement[]} productHTMLArray - Array of product HTML elements
   */
  return getProductHighlights_createClass(ProductHighlights, [{
    key: "getProductHighlights",
    value: function getProductHighlights(productHTMLArray) {
      try {
        var highlightsData = this.extractHighlightsData(productHTMLArray);
        if (highlightsData.length > 1) {}
        var combinedHTML = this.generateCombinedHTML(highlightsData);
        this.renderHighlights(combinedHTML);
      } catch (error) {
        console.error('Error getting product highlights:', error);
      }
    }

    /**
     * @method extractHighlightsData
     * @description Extracts highlights data from product HTML elements
     * @param {HTMLElement[]} productHTMLArray - Array of product HTML elements
     * @returns {Object[]} Array of highlights data objects
     */
  }, {
    key: "extractHighlightsData",
    value: function extractHighlightsData(productHTMLArray) {
      var _this = this;
      return productHTMLArray.map(function (productElement) {
        var highlightsElement = productElement.querySelector('[data-product-highlights]');
        var imagesElement = productElement.querySelector('[data-product-highlight-images]');
        if (!highlightsElement || !imagesElement) {
          console.error('Product highlights or images not found:', productElement);
          return {
            highlights: [{
              highlight_icon: '',
              highlight_copy: '',
              highlight_title: ''
            }],
            productId: productElement.getAttribute('data-id')
          };
        }
        var highlights = _this.parseJSONAttribute(highlightsElement, 'data-product-highlights');
        var images = _this.parseJSONAttribute(imagesElement, 'data-product-highlight-images');
        var fallbackImages = ['https://cdn.shopify.com/s/files/1/0659/3966/9171/files/humbug.svg?v=1744282864', 'https://cdn.shopify.com/s/files/1/0659/3966/9171/files/pushpullcoil.svg?v=1744293852', 'https://cdn.shopify.com/s/files/1/0659/3966/9171/files/heellessneck.svg?v=1744293852', 'https://cdn.shopify.com/s/files/1/0659/3966/9171/files/mapleovermahogony.svg?v=1744293852', 'https://cdn.shopify.com/s/files/1/0659/3966/9171/files/weight-relieved.svg?v=1744293852'];
        if (!highlights || !images) {
          return null;
        }
        return {
          highlights: highlights.map(function (highlight, index) {
            highlight.forEach(function (item, i) {
              item.highlight_icon = images[i] || fallbackImages[i] || 'https://cdn.shopify.com/s/files/1/0659/3966/9171/files/humbug.svg?v=1744282864';
            });
            return highlight;
          }),
          productId: productElement.getAttribute('data-id')
        };
      }).filter(Boolean);
    }

    /**
     * @method parseJSONAttribute
     * @description Parses a JSON-encoded attribute value
     * @param {HTMLElement} element - The element containing the attribute
     * @param {string} attributeName - The name of the attribute to parse
     * @returns {Object|null} Parsed JSON object or null if parsing fails
     */
  }, {
    key: "parseJSONAttribute",
    value: function parseJSONAttribute(element, attributeName) {
      try {
        var encodedData = element.getAttribute(attributeName);
        var decodedData = decodeURIComponent(encodedData);
        return JSON.parse(decodedData);
      } catch (error) {
        console.error("Error parsing ".concat(attributeName, ":"), error);
        return null;
      }
    }

    /**
     * @method generateCombinedHTML
     * @description Generates combined HTML for all product highlights
     * @param {Object[]} highlightsData - Array of highlights data objects
     * @returns {string} Combined HTML string
     */
  }, {
    key: "generateCombinedHTML",
    value: function generateCombinedHTML(highlightsData) {
      var _this2 = this;
      return highlightsData.map(function (_ref, index) {
        var highlights = _ref.highlights,
          productId = _ref.productId;
        var flattenedHighlights = highlights.flat();
        return flattenedHighlights.map(function (item) {
          return _this2.productHighlightsHTMLTemplate(item.highlight_icon, item.key_feature, productId);
        }).join('');
      }).join('');
    }
  }, {
    key: "renderHighlights",
    value:
    /**
     * @method renderHighlights
     * @description Renders the combined highlights HTML and organizes the structure
     * @param {string} combinedHTML - Combined HTML string of all highlights
     */
    function renderHighlights(combinedHTML) {
      var comparisonHighlights = this.createElementWithClasses('div', ['main-product-comparison__highlights', 'd-flex', 'w-full', 'main-product-comparison__subsections--highlights-new']);
      comparisonHighlights.innerHTML = combinedHTML;
      this.compareProductsInfo.appendChild(comparisonHighlights);
      var header = this.createHeader();
      comparisonHighlights.appendChild(header);
      var highlightsContainer = this.createHighlightsContainer();
      this.organizeHighlights(highlightsContainer);
      comparisonHighlights.appendChild(highlightsContainer);
    }

    /**
     * @method createElementWithClasses
     * @description Creates a new HTML element with specified classes
     * @param {string} tagName - HTML tag name
     * @param {string[]} classes - Array of CSS class names
     * @returns {HTMLElement} Newly created HTML element
     */
  }, {
    key: "createElementWithClasses",
    value: function createElementWithClasses(tagName, classes) {
      var _element$classList;
      var element = document.createElement(tagName);
      (_element$classList = element.classList).add.apply(_element$classList, getProductHighlights_toConsumableArray(classes));
      return element;
    }

    /**
     * @method createHeader
     * @description Creates the header element for the highlights section
     * @returns {HTMLElement} Header element
     */
  }, {
    key: "createHeader",
    value: function createHeader() {
      var keyFeaturesHeading = this.compareProductsModal.closest('.compare-products-modal').getAttribute('data-key-features-heading-translation');
      var header = this.createElementWithClasses('div', ['comparison__header']);
      header.innerHTML = "\n      <h5 class=\"comparison__heading\">".concat(keyFeaturesHeading, "</h5>\n      <div class=\"comparison__accordion-toggle\">\n        <svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <rect opacity=\"0.01\" x=\"12\" y=\"4\" width=\"1\" height=\"15\" rx=\"0.5\" fill=\"black\" stroke=\"black\" stroke-width=\"1.2\"/>\n          <rect x=\"5\" y=\"11\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\" stroke=\"black\" stroke-width=\"1.2\"/>\n        </svg>\n      </div>\n    ");
      return header;
    }

    /**
     * @method createHighlightsContainer
     * @description Creates the container for product highlights
     * @returns {HTMLElement} Highlights container element
     */
  }, {
    key: "createHighlightsContainer",
    value: function createHighlightsContainer() {
      return this.createElementWithClasses('div', ['product-highlights-container', 'accordion-content']);
    }

    /**
     * @method organizeHighlights
     * @description Organizes highlight elements into their respective containers
     * @param {HTMLElement} container - The main container for all highlights
     */
  }, {
    key: "organizeHighlights",
    value: function organizeHighlights(container) {
      var _this3 = this;
      var highlights = document.querySelectorAll('.product-highlights');
      highlights.forEach(function (highlight) {
        var highlightType = highlight.getAttribute('data-highlight-type');
        var emptyClass = highlight.classList.contains('product-highlights--empty') ? 'product-highlights--empty' : 'product-highlights--not-empty';
        var highlightItems = document.querySelectorAll("[data-highlight-item=\"".concat(highlightType, "\"]"));
        var highlightContainer = _this3.createElementWithClasses('div', ['product-highlight', emptyClass]);
        highlightContainer.setAttribute('data-highlight-type', highlightType);
        container.classList.add(emptyClass);
        highlightItems.forEach(function (item) {
          return highlightContainer.appendChild(item);
        });
        highlight.remove();
        container.appendChild(highlightContainer);
      });
    }
  }]);
}();
/* harmony default export */ var getProductHighlights = (ProductHighlights);
;// ./src/scripts/components/productDataHandler.js
function productDataHandler_typeof(o) { "@babel/helpers - typeof"; return productDataHandler_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, productDataHandler_typeof(o); }
function productDataHandler_defineProperty(e, r, t) { return (r = productDataHandler_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function productDataHandler_toConsumableArray(r) { return productDataHandler_arrayWithoutHoles(r) || productDataHandler_iterableToArray(r) || productDataHandler_unsupportedIterableToArray(r) || productDataHandler_nonIterableSpread(); }
function productDataHandler_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function productDataHandler_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function productDataHandler_arrayWithoutHoles(r) { if (Array.isArray(r)) return productDataHandler_arrayLikeToArray(r); }
function productDataHandler_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function productDataHandler_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, productDataHandler_toPropertyKey(o.key), o); } }
function productDataHandler_createClass(e, r, t) { return r && productDataHandler_defineProperties(e.prototype, r), t && productDataHandler_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function productDataHandler_toPropertyKey(t) { var i = productDataHandler_toPrimitive(t, "string"); return "symbol" == productDataHandler_typeof(i) ? i : i + ""; }
function productDataHandler_toPrimitive(t, r) { if ("object" != productDataHandler_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != productDataHandler_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function productDataHandler_slicedToArray(r, e) { return productDataHandler_arrayWithHoles(r) || productDataHandler_iterableToArrayLimit(r, e) || productDataHandler_unsupportedIterableToArray(r, e) || productDataHandler_nonIterableRest(); }
function productDataHandler_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function productDataHandler_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return productDataHandler_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? productDataHandler_arrayLikeToArray(r, a) : void 0; } }
function productDataHandler_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function productDataHandler_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function productDataHandler_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Looks up translations for spec titles and items.
 * @param {string} key - The key to translate (e.g., spec title or item key)
 * @returns {string} - The translated value or original key if no translation found
 */
var getTranslation = function getTranslation(key) {
  var isSpecTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!key) return key;

  // Normalize the key for comparison
  var normalizedKey = key.toLowerCase().replace(/[\s_-]+/g, '-');
  normalizedKey = normalizedKey.replace('-specifications', '').replace('-specification', '');

  // Check window.translations first
  if (window.translations && Array.isArray(window.translations)) {
    var translation = window.translations.find(function (t) {
      if (!t || !t.key) return false;
      var translationKey = t.key.toLowerCase().replace(/[\s_-]+/g, '-');
      var isMatch;
      if (translationKey === normalizedKey) {
        isMatch = true;
      } else if (t.key === key) {
        isMatch = true;
      } else if (t.concatenated_handle === normalizedKey) {
        isMatch = true;
      } else {
        isMatch = false;
      }
      return isMatch;
    });
    if (translation && translation.value) {
      return translation.value;
    }
  }

  // Check extended translations
  if (window.algoliaShopify && window.algoliaShopify.extended_translations) {
    var extendedTranslations = window.algoliaShopify.extended_translations;

    // Check if the key exists directly
    if (extendedTranslations[key]) {
      return extendedTranslations[key];
    }

    // Check with normalized key
    if (extendedTranslations[normalizedKey]) {
      return extendedTranslations[normalizedKey];
    }
  }

  // Return original key if no translation found
  return key;
};

/**
 * Generates an HTML template for product specifications.
 *
 * @param {string} spec_title - The title of the specification.
 * @param {Array} spec_item - The specification items.
 * @param {string} spec_copy - Additional specification copy.
 * @param {number} id - The product ID.
 * @param {string} handle - The product handle.
 * @param {number} index - The index of the specification.
 * @returns {string} - HTML string representing the product specification.
 */
var productSpecHTMLTemplate = function productSpecHTMLTemplate(spec_title, spec_item) {
  var _spec_copy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var id = arguments.length > 3 ? arguments[3] : undefined;
  var handle = arguments.length > 4 ? arguments[4] : undefined;
  var itemIndex = arguments.length > 5 ? arguments[5] : undefined;
  // Ensure spec_item is an array
  var items = [];

  // loop through spec_item object and log the key and value
  for (var _i = 0, _Object$entries = Object.entries(spec_item); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = productDataHandler_slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    items.push([key, value]);
  }
  var capitalize = function capitalize(s) {
    return s && String(s[0]).toUpperCase() + String(s).slice(1);
  };
  var propercase = function propercase(s) {
    return s && s.split(' ').map(function (word) {
      return capitalize(word);
    }).join(' ');
  };
  var formatValue = function formatValue(value, key) {
    var formattedValue = Array.isArray(value) && value.length > 0 ? value[0].replace(/\+/g, ' ') : typeof value === 'number' ? value : value.length > 0 ? value.replace(/\+/g, ' ') : '';
    if (key === 'body-shape') {
      formattedValue = formattedValue.replace(/^"|"$/g, '');
    }
    return formattedValue;
  };

  // Get translated spec title
  if (spec_title.includes('hardware') || spec_title.includes('Hardware')) {}
  var translatedSpecTitle = getTranslation(spec_title.replace(/\s+/g, '-'), true);

  // Convert hyphenated object keys to proper sentence case titles
  var formatSpecTitle = function formatSpecTitle(title) {
    // Replace hyphens and underscores with spaces
    var withSpaces = title.replace(/[-_]/g, ' ');
    // Split into words and capitalize first letter of each word
    var words = withSpaces.split(' ');
    var capitalizedWords = words.map(function (word) {
      if (word.toLowerCase() === 'and') return 'and';
      if (word.toLowerCase() === 'or') return 'or';
      if (word.toLowerCase() === 'of') return 'of';
      if (word.toLowerCase() === 'the') return 'the';
      if (word.toLowerCase() === 'in') return 'in';
      if (word.toLowerCase() === 'to') return 'to';
      if (word.toLowerCase() === 'for') return 'for';
      if (word.toLowerCase() === 'with') return 'with';
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return capitalizedWords.join(' ');
  };

  // If no translation found, create a proper title from the original spec_title
  var displayTitle = translatedSpecTitle === spec_title.replace(/\s+/g, '-') ? formatSpecTitle(spec_title) : formatSpecTitle(translatedSpecTitle);

  /* eslint-disable */
  var htmlOutput = "\n  <div class=\"product-specs-container index--".concat(itemIndex, "\" data-type=\"").concat(spec_title.toLowerCase().replace(/\s+/g, '-'), "\" data-is-empty=\"").concat(items.length === 0 ? 'empty' : 'not-empty', "\" data-spec-index=\"").concat(itemIndex, "\" data-product-id=\"").concat(id, "\" data-product-handle=\"").concat(handle, "\" >\n    <div class=\"comparison__header\">\n      <h5 class=\"comparison__heading\">").concat(displayTitle, "</h5>\n      <div class=\"comparison__accordion-toggle\">\n        <svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <rect opacity=\"0.01\" x=\"12\" y=\"4\" width=\"1\" height=\"15\" rx=\"0.5\" fill=\"black\" stroke=\"black\" stroke-width=\"1.2\"/>\n          <rect x=\"5\" y=\"11\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\" stroke=\"black\" stroke-width=\"1.2\"/>\n        </svg>\n      </div>\n    </div> \n    \n    <div class=\"product-specs ").concat(spec_title.toLowerCase(), "\" data-product-specs=\"").concat(spec_title.toLowerCase(), "\">\n      <!-- Add headings column -->\n      <div class=\"product-spec--headings\">\n        <div class=\"product-spec__content\">\n          <div class=\"metafield-rich_text_field\">\n            ").concat(items.map(function (item, index) {
    /* eslint-disable */
    var itemKey = item[0] ? item[0].replace(/\+/g, ' ').replace(/-/g, ' ').replace(/_/g, ' ') : '';
    var translatedItemKey = getTranslation(item[0]) || propercase(itemKey);

    // Format individual spec item keys (like ampType, builtInPowerAmpAttenuation)
    var formatSpecItemKey = function formatSpecItemKey(key) {
      // If the key already has spaces or hyphens, just clean it up
      if (key.includes(' ') || key.includes('-') || key.includes('_')) {
        return key.replace(/[-_]/g, ' ').split(' ').map(function (word) {
          if (word.toLowerCase() === 'and') return 'and';
          if (word.toLowerCase() === 'or') return 'or';
          if (word.toLowerCase() === 'of') return 'of';
          if (word.toLowerCase() === 'the') return 'the';
          if (word.toLowerCase() === 'in') return 'in';
          if (word.toLowerCase() === 'to') return 'to';
          if (word.toLowerCase() === 'for') return 'for';
          if (word.toLowerCase() === 'with') return 'with';
          if (word.toLowerCase() === 'at') return 'at';
          if (word.toLowerCase() === 'by') return 'by';
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
      }

      // Only apply camelCase formatting if it's actually camelCase (has capital letters in the middle)
      if (/[a-z][A-Z]/.test(key)) {
        var withSpaces = key.replace(/([A-Z])/g, ' $1');
        var words = withSpaces.split(' ');
        var capitalizedWords = words.map(function (word) {
          if (word.toLowerCase() === 'and') return 'and';
          if (word.toLowerCase() === 'or') return 'or';
          if (word.toLowerCase() === 'of') return 'of';
          if (word.toLowerCase() === 'the') return 'the';
          if (word.toLowerCase() === 'in') return 'in';
          if (word.toLowerCase() === 'to') return 'to';
          if (word.toLowerCase() === 'for') return 'for';
          if (word.toLowerCase() === 'with') return 'with';
          if (word.toLowerCase() === 'at') return 'at';
          if (word.toLowerCase() === 'by') return 'by';
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        });
        return capitalizedWords.join(' ');
      }

      // For simple words, just capitalize the first letter
      return key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
    };
    var formattedItemKey = formatSpecItemKey(translatedItemKey);

    // Skip the spec row if the name or attribute is set to 'name'
    if (formattedItemKey.toLowerCase() === 'name') {
      return '';
    }
    return "\n                \n              <div class=\"product-spec__row\" role=\"row\" data-content-title=\"".concat(formattedItemKey, "\" data-content-index=\"").concat(index, "\" data-spec-title=\"").concat(spec_title, "\">\n                <div class=\"product-spec__cell product-spec__cell--title\" role=\"rowHeader\">\n                  <strong class=\"product-spec__item-title\"> ").concat(formattedItemKey, "</strong>\n                </div>\n              </div>\n            ");
  }).join(''), "\n            \n          </div>\n        </div>\n      </div>\n\n      <div class=\"product-spec ").concat(items.length === 0 ? 'hidden' : '', "\" data-id=\"").concat(id, "\" data-index=\"").concat(itemIndex, "\" data-spec-title=\"").concat(spec_title, "\">\n        <div class=\"product-spec__content\" data-is-empty=\"").concat(items.length === 0 ? 'empty' : 'not-empty', "\">\n          <div class=\"metafield-rich_text_field\" data-is-empty=\"").concat(items.length === 0 ? 'empty' : 'not-empty', "\" data-spec-item=\"").concat(items.length, "\" data-spec-title=\"").concat(spec_title, "\">\n\n\n           \n\n            ").concat(items.map(function (item, index) {
    var itemKey = item[0] ? item[0].replace(/\+/g, ' ').replace(/-/g, ' ').replace(/_/g, ' ') : '';
    var translatedItemKey = getTranslation(item[0]) || propercase(itemKey);

    // Format individual spec item keys (like ampType, builtInPowerAmpAttenuation)
    var formatSpecItemKey = function formatSpecItemKey(key) {
      // If the key already has spaces or hyphens, just clean it up
      if (key.includes(' ') || key.includes('-') || key.includes('_')) {
        return key.replace(/[-_]/g, ' ').split(' ').map(function (word) {
          if (word.toLowerCase() === 'and') return 'and';
          if (word.toLowerCase() === 'or') return 'or';
          if (word.toLowerCase() === 'of') return 'of';
          if (word.toLowerCase() === 'the') return 'the';
          if (word.toLowerCase() === 'in') return 'in';
          if (word.toLowerCase() === 'to') return 'to';
          if (word.toLowerCase() === 'for') return 'for';
          if (word.toLowerCase() === 'with') return 'with';
          if (word.toLowerCase() === 'at') return 'at';
          if (word.toLowerCase() === 'by') return 'by';
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
      }

      // Only apply camelCase formatting if it's actually camelCase (has capital letters in the middle)
      if (/[a-z][A-Z]/.test(key)) {
        var withSpaces = key.replace(/([A-Z])/g, ' $1');
        var words = withSpaces.split(' ');
        var capitalizedWords = words.map(function (word) {
          if (word.toLowerCase() === 'and') return 'and';
          if (word.toLowerCase() === 'or') return 'or';
          if (word.toLowerCase() === 'of') return 'of';
          if (word.toLowerCase() === 'the') return 'the';
          if (word.toLowerCase() === 'in') return 'in';
          if (word.toLowerCase() === 'to') return 'to';
          if (word.toLowerCase() === 'for') return 'for';
          if (word.toLowerCase() === 'with') return 'with';
          if (word.toLowerCase() === 'at') return 'at';
          if (word.toLowerCase() === 'by') return 'by';
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        });
        return capitalizedWords.join(' ');
      }

      // For simple words, just capitalize the first letter
      return key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
    };
    var formattedItemKey = formatSpecItemKey(translatedItemKey);

    // Skip the spec row if the name or attribute is set to 'name'
    if (formattedItemKey.toLowerCase() === 'name') {
      return '';
    }
    return "\n\n                \n                \n\n              <div class=\"product-spec__row\" data-content-title=\"".concat(formattedItemKey, "\" data-content-index=\"").concat(index, "\" data-spec-title=\"").concat(spec_title, "\">\n               \n                <div class=\"product-spec__cell product-spec__cell--mobile-title d-md-none\">\n                  <strong class=\"product-spec__item-title\"> ").concat(formattedItemKey, "</strong>\n                </div>\n\n                <div class=\"product-spec__cell product-spec__cell--value\" role=\"cell\">\n                  <span class=\"product-spec__item-value\">\n                   ").concat(formatValue(item[1], item[0]), "\n               \n                  </span>\n                </div>\n              </div>\n            ");
  }).join(''), "\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>");
  return htmlOutput;
};

/**
 * Handles product data processing and comparison.
 */
var ProductDataHandler = /*#__PURE__*/function () {
  /**
   * Creates an instance of ProductDataHandler.
   * @param {HTMLElement} container - The container element where the product comparison will be displayed.
   */
  function ProductDataHandler(container) {
    productDataHandler_classCallCheck(this, ProductDataHandler);
    this.container = container;
    this.specsArray = [];
  }

  /**
   * Fetches the product data and generates the HTML structure for comparison.
   *
   * @param {Array} productHTMLArray - Array of HTML elements representing product data.
   * @param {number} numberOfProducts - Total number of products.
   * @param {Array<number>} ids - Array of product IDs.
   * @param {Array<string>} handles - Array of product handles.
   */
  return productDataHandler_createClass(ProductDataHandler, [{
    key: "getProductDataHTML",
    value: function getProductDataHTML(productHTMLArray, numberOfProducts, ids, handles) {
      try {
        this.numberOfProducts = numberOfProducts;
        this.ids = ids;
        this.handles = handles;
        try {
          var combined = this.processProductElements(productHTMLArray);
          this.appendComparisonSpecs(combined);

          // Check if regrouping has been done before calling potentially problematic methods
          var regroupedSpecs = document.querySelectorAll('.specs-regrouped');
          if (regroupedSpecs.length === 0) {
            // Only call these if regrouping hasn't been done yet
            this.groupProductSpecs();
            this.addEmptySpecElements();
          }
        } catch (error) {
          console.error('Error getting specs:', error);
        }
      } catch (error) {
        console.error('Error getting product data:', error);
      }
    }
  }, {
    key: "addEmptySpecElements",
    value: function addEmptySpecElements() {
      var _this = this;
      try {
        // Check if specs have already been regrouped
        var regroupedSpecs = document.querySelectorAll('.specs-regrouped');
        if (regroupedSpecs.length > 0) {
          return;
        }

        // Process containers that haven't been regrouped yet
        productDataHandler_toConsumableArray(document.querySelectorAll('.product-specs-container')).forEach(function (item) {
          var specEls = item.querySelectorAll('.product-spec');
          if (!specEls || specEls.length === 0) {
            console.log('No spec elements found in container');
            return;
          }
          _this.ids.forEach(function (id, i) {
            /* for the current id, find the specEl with the same id */
            var specEl = productDataHandler_toConsumableArray(specEls).find(function (specEl) {
              return specEl && parseInt(specEl.dataset.id) === id;
            });
            if (specEl === undefined) {
              /* If we can't find a matching spec element, try to find a valid reference element */
              var referenceEl = null;
              for (var j = 0; j < specEls.length; j++) {
                if (specEls[j] && specEls[j].parentNode) {
                  referenceEl = specEls[j];
                  break;
                }
              }
              if (!referenceEl) {
                console.log('No valid reference element found for insertion');
                return;
              }

              /* Create an empty spec element */
              var emptySpecEl = document.createElement('div');
              emptySpecEl.classList.add('product-spec');
              emptySpecEl.classList.add('product-spec--empty');
              emptySpecEl.dataset.id = id;
              emptySpecEl.dataset.index = i;
              emptySpecEl.innerHTML = "\n            <div class=\"product-spec__content\" data-is-empty=\"empty\">\n              <div class=\"metafield-rich_text_field\" data-is-empty=\"empty\">\n              </div>\n            </div>\n            ";

              /* Insert it at the appropriate position */
              referenceEl.parentNode.insertBefore(emptySpecEl, referenceEl);
            }
          });
        });
        this.groupProductSpecs();
      } catch (error) {
        console.error('Error in addEmptySpecElements:', error);
      }
    }

    /**
     * Processes the HTML elements for each product.
     *
     * @param {Array} productHTMLArray - Array of product HTML elements.
     * @returns {string} - The combined HTML string for all product specifications.
     */
  }, {
    key: "processProductElements",
    value: function processProductElements(productHTMLArray) {
      var _this2 = this;
      this.specsArray = [];
      productHTMLArray.forEach(function (item) {
        _this2.prepreSpecArrays(item);
      });
      this.productHTMLArray = productHTMLArray;
      var processedProductHTMLArray = productHTMLArray.map(function (item, index) {
        return _this2.extractProductData(item, index);
      }).filter(Boolean).join('');

      /* If the newSpecsHTML is not empty, append it to the processedProductHTMLArray at the index of where the empty specs were found.
       */

      return processedProductHTMLArray;
    }

    /**
     * Gets and decodes attribute data from a DOM element.
     *
     * @param {Element} element - The DOM element.
     * @param {string} selector - The CSS selector or attribute identifier.
     * @param {boolean} [multiple=false] - Whether to query for multiple elements.
     * @returns {any|null} - The decoded data or null if not found/decodable.
     */
  }, {
    key: "getAttributeData",
    value: function getAttributeData(element, selector) {
      var multiple = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      try {
        if (multiple) {
          var dataElements = element.querySelectorAll(selector);
          if (!dataElements) return null;
          var specNames = productDataHandler_toConsumableArray(dataElements).map(function (item) {
            return item.getAttribute('data-product-specs');
          });
          var encodedData = productDataHandler_toConsumableArray(dataElements).map(function (item, index) {
            try {
              var rawData = item.getAttribute("data-spec-".concat(specNames[index]));
              // Decode the raw attribute value
              var decodedValue = decodeURIComponent(rawData);
              var specData = "{\"".concat(specNames[index], "\": ").concat(decodedValue, "}");
              return specData;
            } catch (error) {
              console.error('Error decoding individual spec data:', error, item);
              throw error;
            }
          });

          // If the specData strings are already decoded when built,
          // you might not need to call decodeURIComponent again here.
          var decodedData = encodedData.map(function (item) {
            try {
              // Remove the extra decoding if not needed.
              return JSON.parse(item);
            } catch (error) {
              console.error('Error parsing spec data:', error, item);
              throw error;
            }
          });
          return decodedData;
        } else {
          var dataElement = element.querySelector(selector);
          if (!dataElement) return null;
          var _encodedData = dataElement.getAttribute(selector.slice(1, -1));
          return decodeURIComponent(_encodedData);
        }
      } catch (error) {
        console.error('Error in getAttributeData:', error);
        return null;
      }
    }

    /**
     * Generates the HTML for product specifications.
     *
     * @param {Object} productSpecs - Object containing categorized specifications
     * @param {number} id - The product ID.
     * @returns {string} - HTML string representing the product specifications.
     */
  }, {
    key: "generateSpecHTML",
    value: function generateSpecHTML(productSpecs, id, indexMain) {
      var _this3 = this;
      if (id) {
        return Object.entries(productSpecs).map(function (_ref, index) {
          var _ref2 = productDataHandler_slicedToArray(_ref, 2),
            specTitle = _ref2[0],
            specItems = _ref2[1];
          return _this3.processSpec(productDataHandler_defineProperty({}, specTitle, specItems[indexMain]), id, _this3.handles[id], index);
        }).filter(Boolean).join('');
      }
      return '';
    }

    /**
     * Generates the HTML for product specifications.
     *
     * @param {Array} array - The product ID.
     * @returns {Array} - HTML string representing the product specifications.
     */
  }, {
    key: "normalizeGroupSpecs",
    value: function normalizeGroupSpecs(array) {
      // Handle null or undefined array
      if (!array || !Array.isArray(array)) {
        return [];
      }

      // Collect all unique keys from non-null items
      var allKeys = array.reduce(function (keys, item) {
        if (item && productDataHandler_typeof(item) === 'object') {
          Object.keys(item).forEach(function (key) {
            if (key && !keys.includes(key)) {
              keys.push(key);
            }
          });
        }
        return keys;
      }, []);

      // Add missing keys to each object with empty string value
      return array.map(function (item) {
        // If item is null or undefined, create a new object
        var normalizedItem = item && productDataHandler_typeof(item) === 'object' ? Object.assign({}, item) : {};

        // Add all missing keys with empty string values
        allKeys.forEach(function (key) {
          if (key && !Object.prototype.hasOwnProperty.call(normalizedItem, key)) {
            normalizedItem[key] = '';
          }
        });
        return normalizedItem;
      });
    }

    /**
     * Extracts the product data from the provided HTML element.
     *
     * @param {HTMLElement} productElement - The HTML element representing the product.
     */
  }, {
    key: "prepreSpecArrays",
    value: function prepreSpecArrays(productElement) {
      var specs = this.getAttributeData(productElement, '[data-product-specs]', true);
      var highlights = this.getAttributeData(productElement, '[data-product-highlights]');
      if (!specs && !highlights) return null;
      this.specsArray.push(specs || []);
    }

    /**
     * Extracts the product data from the provided HTML element.
     *
     * @param {HTMLElement} productElement - The HTML element representing the product.
     * @returns {string|null} - The generated HTML for the product specs, or null if no data.
     */
  }, {
    key: "extractProductData",
    value: function extractProductData(productElement, index) {
      var _this4 = this;
      var id = parseInt(productElement.getAttribute('data-id'));
      var groupedSpecs = this._groupProductsByAttribute(this.specsArray);
      if (this.specsArray.length === this.productHTMLArray.length) {
        Object.keys(groupedSpecs).forEach(function (key) {
          if (Array.isArray(groupedSpecs[key])) {
            groupedSpecs[key] = _this4.normalizeGroupSpecs(groupedSpecs[key]);
          }
        });
      }
      return this.generateSpecHTML(groupedSpecs, id, index);
    }

    /**
     * Groups products from specsArray by their attribute while maintaining original order.
     * Returns an array with the same length as specsArray, with duplicate products
     * referencing the first occurrence of that product.
     *
     * @param {Array} specsArray - Array of product specifications
     * @returns {Array} Array of grouped product specifications
     */
  }, {
    key: "_groupProductsByAttribute",
    value: function _groupProductsByAttribute(specsArray) {
      try {
        if (!specsArray || !specsArray.length) {
          console.warn('No specs array available to group');
          return {};
        }

        // Create result object to store grouped specs
        var groupedSpecs = {};

        // Process each product's specifications
        specsArray.forEach(function (productSpecs) {
          if (!productSpecs || !productSpecs.length) {
            return;
          }

          // Process each specification group (electronics, miscellaneous, etc.)
          productSpecs.forEach(function (specGroup) {
            // Get the specification type (first key in the object)
            var specType = Object.keys(specGroup)[0];
            var specData = specGroup[specType];

            // Initialize array for this spec type if it doesn't exist
            if (!groupedSpecs[specType]) {
              groupedSpecs[specType] = [];
            }

            // Add the specification data to the appropriate group
            groupedSpecs[specType].push(specData);
          });
        });
        return groupedSpecs;
      } catch (error) {
        console.error('Error grouping product specs:', error);
        return {}; // Return empty object if grouping fails
      }
    }

    /**
     * Processes the individual specification item and generates its HTML representation.
     *
     * @param {Object} spec - The specification object
     * @param {number} id - The product ID
     * @param {string} handle - The product handle
     * @param {number} index - The specification index
     * @returns {string|null} - HTML string for the specification or null if no data
     */
  }, {
    key: "processSpec",
    value: function processSpec(spec, id, handle, index) {
      var specTitle = Object.keys(spec)[0].replace(/\+/g, ' ').replace(/-/g, ' ');
      var specItems = Object.values(spec)[0];
      var specCopy = '';
      return productSpecHTMLTemplate(specTitle, specItems, specCopy, id, handle, index);
    }

    /**
     * Appends the combined comparison specs to the container.
     *
     * @param {string} combined - The combined HTML string of product specs.
     */
  }, {
    key: "appendComparisonSpecs",
    value: function appendComparisonSpecs(combined) {
      var _this5 = this;
      var compareProductsInfo = this.container.querySelector('.compare-products-modal__info');
      var comparisonSpecs = document.createElement('div');
      comparisonSpecs.classList.add('main-product-comparison__subsections', 'd-flex', 'w-full', 'flex-column', 'main-product-comparison__subsections--new');
      comparisonSpecs.innerHTML = combined;
      compareProductsInfo.appendChild(comparisonSpecs);

      // Apply the regrouping directly to avoid issues with the original structure
      setTimeout(function () {
        try {
          _this5._groupSpecContentElsBySharedContentTitleTogetherWithSameSpecTitleHeading();
        } catch (error) {
          console.error('Error applying regrouping:', error);
        }
      }, 100);
    }

    /**
     * Groups product specifications by their "data-product-specs" attributes,
     * removes existing spec containers, re-renders them in grouped sections,
     * and syncs the spec content across all products to ensure each spec group
     * has matching titles (inserting empty placeholders where needed).
     *
     * @throws {Error} Logs an error if anything goes wrong in processing.
     * @returns {void}
     */
  }, {
    key: "groupProductSpecs",
    value: function groupProductSpecs() {
      try {
        // Check if specs have already been regrouped by _groupSpecContentElsBySharedContentTitleTogetherWithSameSpecTitleHeading
        var regroupedSpecs = document.querySelectorAll('.specs-regrouped');
        if (regroupedSpecs.length > 0) {
          console.log('Specs already regrouped, skipping groupProductSpecs');
          return;
        }
        var containers = document.querySelectorAll('.product-specs-container');
        if (!containers || !containers.length) return;

        // 1. Group specs by data-product-specs
        var groupedSpecs = this._groupSpecsByType(containers);

        // 2. Clear all existing containers
        containers.forEach(function (container) {
          return container.remove();
        });

        // 3. Render new grouped containers
        this._renderGroupedContainers(groupedSpecs);

        // 4. Sync all product specs (inserts missing spec entries)
        try {
          this._syncAllProductSpecs();
          this._reorderSpecByContentTitleAlphabetically();
          this._groupSpecContentElsBySharedContentTitleTogetherWithSameSpecTitleHeading();
        } catch (err) {
          console.error('syncAllProductSpecs failed:', err);
          return false;
        }
      } catch (err) {
        console.error('groupProductSpecs failed:', err);
        return false;
      }
    }

    /**
     * Reorganizes specs into a grid where each row represents a spec type,
     * with one title cell and all product values horizontally aligned.
     *
     * @returns {void}
     */
  }, {
    key: "_groupSpecContentElsBySharedContentTitleTogetherWithSameSpecTitleHeading",
    value: function _groupSpecContentElsBySharedContentTitleTogetherWithSameSpecTitleHeading() {
      try {
        // Process each product specs container (e.g., electronics, dimensions, etc.)
        var specContainers = document.querySelectorAll('.product-specs[data-product-specs]');
        if (!specContainers.length) return;
        specContainers.forEach(function (specContainer) {
          // Get the spec type (e.g., electronics, dimensions)
          var specType = specContainer.getAttribute('data-product-specs');
          if (!specType) return;

          // Get existing product columns
          var productColumns = Array.from(specContainer.querySelectorAll('.product-spec:not(.product-spec--headings)'));
          if (!productColumns.length) return;

          // Get all unique content titles across all products
          var contentTitles = new Set();
          productColumns.forEach(function (column) {
            var rows = column.querySelectorAll('.product-spec__row[data-content-title]');
            rows.forEach(function (row) {
              contentTitles.add(row.getAttribute('data-content-title'));
            });
          });

          // Create a new metafield container for the reorganized specs
          var newMetafield = document.createElement('div');
          newMetafield.className = 'metafield-rich_text_field';

          // For each unique content title, create a combined row with all product values
          Array.from(contentTitles).sort().forEach(function (title, index) {
            // Create the main row container
            var rowContainer = document.createElement('div');
            rowContainer.className = 'product-spec__row';
            rowContainer.setAttribute('data-content-title', title);
            rowContainer.setAttribute('data-content-index', index);
            rowContainer.setAttribute('data-spec-title', specType);

            // Create the title cell
            var titleCell = document.createElement('div');
            titleCell.className = 'product-spec__cell product-spec__cell--title';
            titleCell.innerHTML = "<strong class=\"product-spec__item-title\">".concat(title, "</strong>");

            // Create the container for all product values
            var valuesContainer = document.createElement('div');
            valuesContainer.className = 'product-spec__cell product-spec__cell--items';

            // Add each product's value for this spec
            productColumns.forEach(function (column) {
              var productId = column.getAttribute('data-id');
              var matchingRow = column.querySelector(".product-spec__row[data-content-title=\"".concat(title, "\"]"));
              var valueCell;
              if (matchingRow) {
                // Extract the value cell from the matching row
                var existingValueCell = matchingRow.querySelector('.product-spec__cell--value');
                valueCell = existingValueCell.cloneNode(true);
              } else {
                // Create an empty value cell if this product doesn't have this spec
                valueCell = document.createElement('div');
                valueCell.className = 'product-spec__cell product-spec__cell--value';
                valueCell.innerHTML = '<span class="product-spec__item-value product-spec__item-value--empty">-</span>';
              }

              // Add product ID for reference
              if (productId) {
                valueCell.setAttribute('data-product-id', productId);
              }
              valuesContainer.appendChild(valueCell);
            });

            // Assemble the row
            rowContainer.appendChild(titleCell);
            rowContainer.appendChild(valuesContainer);
            newMetafield.appendChild(rowContainer);
          });

          // Create a new headings container with the new structure
          var newHeadingsContainer = document.createElement('div');
          newHeadingsContainer.className = 'product-spec--headings';
          var headingsContent = document.createElement('div');
          headingsContent.className = 'product-spec__content';
          headingsContent.appendChild(newMetafield);
          newHeadingsContainer.appendChild(headingsContent);

          // Remove all existing content
          specContainer.innerHTML = '';

          // Add the new restructured content
          specContainer.appendChild(newHeadingsContainer);

          // Mark as processed
          specContainer.classList.add('specs-regrouped');
          specContainer.setAttribute('data-specs-count', productColumns.length);
        });
      } catch (error) {
        console.error('Error in _groupSpecContentElsBySharedContentTitleTogetherWithSameSpecTitleHeading:', error);
      }
    }

    /**
     * Reorders specification items within a given metafield container alphabetically
     * based on their `data-content-title` attribute.
     *
     * @param {HTMLElement} metafieldContainer - The container element with class "metafield-rich_text_field"
     * that holds the product specification items.
     * @returns {void}
     */
  }, {
    key: "reorderProductSpecs",
    value: function reorderProductSpecs(metafieldContainer) {
      try {
        // Select all product spec items with a data-content-title attribute.
        var specItems = metafieldContainer.querySelectorAll('.product-spec__row[data-content-title]');
        if (!specItems.length) {
          console.warn('No product-spec__item found in container:', metafieldContainer);
          return;
        }

        // Convert NodeList to Array and sort alphabetically (case-insensitive)
        var sortedItems = Array.from(specItems).sort(function (a, b) {
          var titleA = (a.getAttribute('data-content-title') || '').toLowerCase();
          var titleB = (b.getAttribute('data-content-title') || '').toLowerCase();
          return titleA.localeCompare(titleB);
        });

        // Reinsert each sorted item into the container.
        // Appending an already-existing element moves it to the new position.
        sortedItems.forEach(function (sortedItem) {
          return metafieldContainer.appendChild(sortedItem);
        });
      } catch (error) {
        console.error('Error reordering product specs:', error);
      }
    }

    /**
     * Iterates through all product specs containers and reorders the spec items
     * alphabetically based on their data-content-title attribute.
     *
     * @returns {void}
     */
  }, {
    key: "_reorderSpecByContentTitleAlphabetically",
    value: function _reorderSpecByContentTitleAlphabetically() {
      var _this6 = this;
      try {
        // Select all parent containers that hold individual spec sets.
        var containers = document.querySelectorAll('.product-specs-container');
        if (!containers.length) {
          console.warn('No .product-specs-container found.');
          return;
        }
        containers.forEach(function (container) {
          // Within each container, select the spec blocks.
          var specContainers = container.querySelectorAll('.product-specs');
          specContainers.forEach(function (specContainer) {
            // Within each spec block, select the metafield container(s)
            var metafieldContainers = specContainer.querySelectorAll('.metafield-rich_text_field');
            if (!metafieldContainers.length) {
              console.warn('No .metafield-rich_text_field found in specContainer:', specContainer);
              return;
            }

            // For each metafield container, reorder the spec items.
            metafieldContainers.forEach(function (metafieldContainer) {
              _this6.reorderProductSpecs(metafieldContainer);
            });
          });
        });
      } catch (error) {
        console.error('Error in _reorderSpecByContentTitleAlphabetically:', error);
      }
    }

    /**
     * Private helper method that groups specs by their "data-product-specs" value.
     *
     * @param {NodeListOf<Element>} containers - Collection of .product-specs-container elements
     * @returns {Object<string, string[]>} An object mapping spec types to an array of HTML strings
     * @private
     */
  }, {
    key: "_groupSpecsByType",
    value: function _groupSpecsByType(containers) {
      var groupedSpecs = {};
      containers.forEach(function (container) {
        var specs = container.querySelector('.product-specs');
        if (!specs) return;
        var specType = specs.getAttribute('data-product-specs');
        if (!groupedSpecs[specType]) {
          groupedSpecs[specType] = [];
        }
        groupedSpecs[specType].push(specs.innerHTML);
      });
      return groupedSpecs;
    }

    /**
     * Private helper method that renders grouped container elements into the DOM.
     *
     * @param {Object<string, string[]>} groupedSpecs - Object mapping spec types to arrays of HTML strings
     * @returns {void}
     * @private
     */
  }, {
    key: "_renderGroupedContainers",
    value: function _renderGroupedContainers(groupedSpecs) {
      var _this7 = this;
      var mainDiv = document.querySelector('.main-product-comparison__subsections--new');
      if (!mainDiv) {
        console.warn('No .main-product-comparison__subsections--new element found to append specs.');
        return;
      }
      Object.entries(groupedSpecs).forEach(function (_ref3, index) {
        var _ref4 = productDataHandler_slicedToArray(_ref3, 2),
          specType = _ref4[0],
          specArray = _ref4[1];
        var newContainer = document.createElement('div');
        newContainer.className = 'product-specs-container';
        newContainer.setAttribute('data-type', specType.toLowerCase().replace(/\s+/g, '-'));
        newContainer.setAttribute('data-spec-index', index.toString());

        // Create the container header
        var header = _this7._createSpecHeader(specType, index);

        // Create the specs container
        var specsDiv = document.createElement('div');
        specsDiv.className = 'product-specs accordion-content';
        specsDiv.setAttribute('data-product-specs', specType);
        specsDiv.innerHTML = specArray.join('');
        newContainer.appendChild(header);
        newContainer.appendChild(specsDiv);
        mainDiv.appendChild(newContainer);
      });
    }

    /**
     * Private helper to create the comparison header element (with toggle).
     *
     * @param {string} specType - The spec type (e.g., "hardware", "dimensions")
     * @param {number} index - Index of the spec group
     * @returns {HTMLDivElement} The header container with title and toggle
     * @private
     */
  }, {
    key: "_createSpecHeader",
    value: function _createSpecHeader(specType, index) {
      var header = document.createElement('div');
      header.className = 'comparison__header';

      // Get translated spec type
      var translatedSpecType = getTranslation(specType);

      // Capitalize first letter of translated spec type, then take the first word only
      var headerText = translatedSpecType.charAt(0).toUpperCase() + translatedSpecType.slice(1);
      headerText = headerText.split(' ')[0];

      // Determine if the toggle is active
      var isActive = index !== 0 && window.matchMedia('(max-width: 991px)').matches ? '' : '';
      header.innerHTML = "\n    <h5 class=\"comparison__heading\">".concat(headerText, "</h5>\n    <div class=\"comparison__accordion-toggle ").concat(isActive, "\">\n      <svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\"\n           xmlns=\"http://www.w3.org/2000/svg\" class=\"").concat(isActive, "\">\n        <rect opacity=\"0.01\" x=\"12\" y=\"4\" width=\"1\" height=\"15\" rx=\"0.5\"\n              fill=\"black\" stroke=\"black\" stroke-width=\"1.2\"/>\n        <rect x=\"5\" y=\"11\" width=\"15\" height=\"1\" rx=\"0.5\"\n              fill=\"black\" stroke=\"black\" stroke-width=\"1.2\"/>\n      </svg>\n    </div>\n  ");
      return header;
    }

    /**
     * Private helper method that ensures each .product-spec has an entry for every
     * title found across all specs in the same container (inserting an empty placeholder if missing).
     *
     * @returns {void}
     * @private
     */
  }, {
    key: "_syncAllProductSpecs",
    value: function _syncAllProductSpecs() {
      try {
        // Get all containers once
        var productSpecsContainers = productDataHandler_toConsumableArray(document.querySelectorAll('.product-specs[data-product-specs]'));
        productSpecsContainers.forEach(function (container) {
          // Get all specs for this container once
          var productSpecs = productDataHandler_toConsumableArray(container.querySelectorAll('.product-spec'));

          // Collect all unique titles across these product specs
          var allContentTitles = new Set();
          productSpecs.forEach(function (spec) {
            var contents = spec.querySelectorAll('.product-spec__content');
            contents.forEach(function (content) {
              var title = content.getAttribute('data-content-title');
              if (title) allContentTitles.add(title);
            });
          });

          // Convert to sorted array
          var sortedTitles = Array.from(allContentTitles).sort();

          // Process each spec once
          productSpecs.forEach(function (spec) {
            var specContent = spec.querySelector('.product-spec__content');
            if (!specContent) return;
            var richTextField = specContent.querySelector('.metafield-rich_text_field');
            if (!richTextField) return;

            // Get existing titles for this spec
            var existingTitles = new Set(productDataHandler_toConsumableArray(spec.querySelectorAll('.product-spec__content')).map(function (content) {
              return content.getAttribute('data-content-title');
            }));

            // Create fragment to batch DOM updates
            var fragment = document.createDocumentFragment();
            var needsUpdate = false;

            // Add missing titles
            sortedTitles.forEach(function (title, index) {
              if (!existingTitles.has(title)) {
                needsUpdate = true;
                var emptyContent = document.createElement('div');
                emptyContent.className = 'product-spec__item product-spec__content';
                emptyContent.setAttribute('data-content-title', title);
                emptyContent.setAttribute('data-content-index', index);
                emptyContent.innerHTML = "\n                <strong class=\"product-spec__item-title\"> ".concat(title, "</strong>\n                <em class=\"product-spec__item-value product-spec__item-value--empty\"> - </em>\n              ");
                fragment.appendChild(emptyContent);
              }
            });

            // Only update DOM if necessary
            if (needsUpdate) {
              richTextField.appendChild(fragment);
            }
          });
        });
        return true;
      } catch (err) {
        console.error('syncAllProductSpecs failed:', err);
        return false;
      }
    }

    /**
     * Initializes compare functionality for the product.
     * @param {HTMLElement} productElement - The product element to initialize compare functionality for.
     */
  }, {
    key: "initializeCompare",
    value: function initializeCompare(productElement) {
      var compareButton = productElement.querySelector('.card__compare[data-action="compare"]');
      var removeButton = productElement.querySelector('.card__compare[data-action="remove"]');
      if (!compareButton || !removeButton) return;
      var productHandle = productElement.getAttribute('data-handle');
      var productType = compareButton.getAttribute('data-product-type');
      this.setupCompareButtons(compareButton, removeButton, productHandle, productType);
      this.updateCompareButtonState(compareButton, removeButton, productHandle);
    }

    /**
     * Sets up event listeners for compare and remove buttons.
     * @param {HTMLElement} compareButton - The compare button element.
     * @param {HTMLElement} removeButton - The remove button element.
     * @param {string} productHandle - The product handle.
     * @param {string} productType - The product type.
     */
  }, {
    key: "setupCompareButtons",
    value: function setupCompareButtons(compareButton, removeButton, productHandle, productType) {
      var _this8 = this;
      compareButton.addEventListener('click', function () {
        _this8.handleCompareClick(compareButton, removeButton, productHandle, productType);
      });
      removeButton.addEventListener('click', function () {
        _this8.handleRemoveClick(compareButton, removeButton, productHandle, productType);
      });
    }

    /**
     * Handles the compare button click event.
     * @param {HTMLElement} compareButton - The compare button element.
     * @param {HTMLElement} removeButton - The remove button element.
     * @param {string} productHandle - The product handle.
     * @param {string} productType - The product type.
     */
  }, {
    key: "handleCompareClick",
    value: function handleCompareClick(compareButton, removeButton, productHandle, productType) {
      var products = this.getCompareProducts();
      var maxProducts = window.matchMedia('(max-width: 991px)').matches ? 2 : 3;
      if (products.length >= maxProducts) {
        console.warn('Maximum number of products for comparison reached.');
        return;
      }
      if (products.includes(productHandle)) return;
      var existingProductTypes = this.getExistingProductTypes();
      if (!existingProductTypes.includes(productType) && existingProductTypes.length > 0) {
        console.warn('Product type of selected product is not allowed to be compared.');
        return;
      }
      products.push(productHandle);
      this.setCompareProducts(products);
      this.updateCompareButtonState(compareButton, removeButton, productHandle);
      this.dispatchCompareEvent(productHandle, productType);
    }

    /**
     * Handles the remove button click event.
     * @param {HTMLElement} compareButton - The compare button element.
     * @param {HTMLElement} removeButton - The remove button element.
     * @param {string} productHandle - The product handle.
     * @param {string} productType - The product type.
     */
  }, {
    key: "handleRemoveClick",
    value: function handleRemoveClick(compareButton, removeButton, productHandle, productType) {
      var products = this.getCompareProducts();
      var index = products.indexOf(productHandle);
      if (index > -1) {
        products.splice(index, 1);
        this.setCompareProducts(products);
        this.updateCompareButtonState(compareButton, removeButton, productHandle);
        this.dispatchRemoveEvent(productHandle, productType);
      }
    }

    /**
     * Updates the state of compare and remove buttons.
     * @param {HTMLElement} compareButton - The compare button element.
     * @param {HTMLElement} removeButton - The remove button element.
     * @param {string} productHandle - The product handle.
     */
  }, {
    key: "updateCompareButtonState",
    value: function updateCompareButtonState(compareButton, removeButton, productHandle) {
      var products = this.getCompareProducts();
      var isCompared = products.includes(productHandle);
      compareButton.classList.toggle('hidden', isCompared);
      removeButton.classList.toggle('hidden', !isCompared);
      compareButton.disabled = isCompared;
    }

    /**
     * Gets the list of products being compared from localStorage.
     * @returns {Array<string>} Array of product handles.
     */
  }, {
    key: "getCompareProducts",
    value: function getCompareProducts() {
      var products = localStorage.getItem('compare_products');
      return products ? JSON.parse(products) : [];
    }

    /**
     * Sets the list of products being compared in localStorage.
     * @param {Array<string>} products - Array of product handles.
     */
  }, {
    key: "setCompareProducts",
    value: function setCompareProducts(products) {
      localStorage.setItem('compare_products', JSON.stringify(products));
      localStorage.setItem('compare_products_expiration', new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString());
    }

    /**
     * Gets the list of product types currently being compared.
     * @returns {Array<string>} Array of product types.
     */
  }, {
    key: "getExistingProductTypes",
    value: function getExistingProductTypes() {
      return productDataHandler_toConsumableArray(document.querySelectorAll('.compare-selections [data-product-type]')).map(function (el) {
        return el.getAttribute('data-product-type');
      });
    }

    /**
     * Dispatches a custom event when a product is added to comparison.
     * @param {string} productHandle - The product handle.
     * @param {string} productType - The product type.
     */
  }, {
    key: "dispatchCompareEvent",
    value: function dispatchCompareEvent(productHandle, productType) {
      this.container.dispatchEvent(new CustomEvent('product:compare', {
        bubbles: true,
        detail: {
          productHandle: productHandle,
          productType: productType
        }
      }));
    }

    /**
     * Dispatches a custom event when a product is removed from comparison.
     * @param {string} productHandle - The product handle.
     * @param {string} productType - The product type.
     */
  }, {
    key: "dispatchRemoveEvent",
    value: function dispatchRemoveEvent(productHandle, productType) {
      this.container.dispatchEvent(new CustomEvent('product:remove-compare', {
        bubbles: true,
        detail: {
          productHandle: productHandle,
          productType: productType
        }
      }));
    }
  }]);
}();
/* harmony default export */ var productDataHandler = (ProductDataHandler);
;// ./src/scripts/lang/algoliaTranslations.js
/**
 * @fileoverview Handles translations for Algolia search functionality by processing
 * and decoding translation strings from the global window.defaultAlgoliaTranslations object.
 */

/**
 * Object that will store the processed translation strings.
 * @type {Object.<string, string>}
 */
var languageStrings = {};

/**
 * Safely decodes URI components and HTML entities from a string.
 *
 * @param {*} str - The string to decode (or any value that might be a string)
 * @returns {*} The decoded string, or the original value if not a string or if decoding fails
 */
var safeDecodeURI = function safeDecodeURI(str) {
  try {
    // Return the input as is if it's not a string
    if (typeof str !== 'string') return str;
    var decoded = str;

    // Decode URI components (e.g., %20 → space)
    decoded = decodeURIComponent(decoded);

    // Decode HTML entities (e.g., &amp; → &) using textarea element
    var textArea = document.createElement('textarea');
    textArea.innerHTML = decoded;
    decoded = textArea.value;
    return decoded;
  } catch (e) {
    // Log the error and return the original string if decoding fails
    console.warn('Failed to decode:', str);
    console.warn('Error:', e);
    return str;
  }
};

// Process each translation string from the global Algolia translations object
Object.keys(window.defaultAlgoliaTranslations).forEach(function (key) {
  languageStrings[key] = safeDecodeURI(window.defaultAlgoliaTranslations[key]);
});

;// ./src/scripts/components/productDescriptionHandler.js
function productDescriptionHandler_typeof(o) { "@babel/helpers - typeof"; return productDescriptionHandler_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, productDescriptionHandler_typeof(o); }
function productDescriptionHandler_toConsumableArray(r) { return productDescriptionHandler_arrayWithoutHoles(r) || productDescriptionHandler_iterableToArray(r) || productDescriptionHandler_unsupportedIterableToArray(r) || productDescriptionHandler_nonIterableSpread(); }
function productDescriptionHandler_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function productDescriptionHandler_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return productDescriptionHandler_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? productDescriptionHandler_arrayLikeToArray(r, a) : void 0; } }
function productDescriptionHandler_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function productDescriptionHandler_arrayWithoutHoles(r) { if (Array.isArray(r)) return productDescriptionHandler_arrayLikeToArray(r); }
function productDescriptionHandler_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function productDescriptionHandler_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function productDescriptionHandler_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, productDescriptionHandler_toPropertyKey(o.key), o); } }
function productDescriptionHandler_createClass(e, r, t) { return r && productDescriptionHandler_defineProperties(e.prototype, r), t && productDescriptionHandler_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function productDescriptionHandler_toPropertyKey(t) { var i = productDescriptionHandler_toPrimitive(t, "string"); return "symbol" == productDescriptionHandler_typeof(i) ? i : i + ""; }
function productDescriptionHandler_toPrimitive(t, r) { if ("object" != productDescriptionHandler_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != productDescriptionHandler_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/**
 * Handles product descriptions in a comparison modal.
 */
var ProductDescriptionHandler = /*#__PURE__*/function () {
  /**
   * Creates an instance of ProductDescriptionHandler.
   * @param {string} selector - The CSS selector for the compare products modal.
   */
  function ProductDescriptionHandler(selector, infoSelector) {
    productDescriptionHandler_classCallCheck(this, ProductDescriptionHandler);
    this.compareProductsModal = document.querySelector(selector);
    this.compareProductsInfo = document.querySelector(infoSelector);
  }

  /**
   * Processes an array of product HTML elements to extract and display featured descriptions.
   * @param {HTMLElement[]} productHTMLArray - An array of product HTML elements.
   */
  return productDescriptionHandler_createClass(ProductDescriptionHandler, [{
    key: "getProductFeaturedDescriptionData",
    value: function getProductFeaturedDescriptionData(productHTMLArray) {
      try {
        var dataIdEls = productDescriptionHandler_toConsumableArray(this.compareProductsInfo.querySelectorAll('[data-id]'));
        var dataIds = dataIdEls.map(function (element) {
          var dataId = element.getAttribute('data-id');
          return dataId;
        });
        this.dataIds = dataIds;
        productHTMLArray.forEach(this.processProductElement.bind(this));
        this.groupDescriptions();
        this.readMoreToggle();
      } catch (error) {
        console.error('Error in getProductFeaturedDescriptionData:', error);
      }
    }
  }, {
    key: "readMoreToggle",
    value: function readMoreToggle() {
      var _this = this;
      this.compareProductsInfo.querySelectorAll('[js-toggle-description]').forEach(function (element) {
        element.addEventListener('click', function (event) {
          event.preventDefault();
          var id = event.target.getAttribute('js-toggle-description');
          var fullDescription = _this.compareProductsInfo.querySelector("[js-full-description=\"".concat(id, "\"]"));
          event.target.parentNode.querySelector('.product-featured-description__read-more').classList.toggle('hidden');
          event.target.parentNode.querySelector('.product-featured-description__read-less').classList.toggle('hidden');
          event.target.parentNode.querySelector('.short-description').classList.toggle('hidden');
          fullDescription.classList.toggle('hidden');
        });
      });
    }

    /**
     * Processes a single product element to extract and append its featured description.
     * @param {HTMLElement} productElement - The product HTML element to process.
     */
  }, {
    key: "processProductElement",
    value: function processProductElement(productElement) {
      var featuredDescriptionElement = productElement.querySelector('[data-unknown-metafield="featured_description"]') || productElement.querySelector('[data-product-description]');
      var prodId = parseInt(productElement.getAttribute('data-id'));
      if (!featuredDescriptionElement) {
        console.error('Featured description element not found:', productElement);
        this.appendFeaturedDescription('', prodId, '');
        return;
      }
      try {
        var description = this.extractDescription(featuredDescriptionElement);
        var truncatedDescription = this.truncateDescription(description);
        this.appendFeaturedDescription(truncatedDescription, prodId, description);
      } catch (error) {
        console.error('Error processing product element:', error);
      }
    }

    /**
     * Extracts the description from a featured description element.
     * @param {HTMLElement} element - The element containing the encoded description data.
     * @returns {string} The extracted description.
     */
  }, {
    key: "extractDescription",
    value: function extractDescription(element) {
      var encodedData = element.getAttribute('data-unknown-metafield-value') || element.getAttribute('data-product-description');
      var decodedData = decodeURIComponent(encodedData);
      var jsonData = JSON.parse(decodedData);
      if (jsonData.children) {
        return jsonData.children[0].children[0].value.replace(/\+/g, ' ');
      } else {
        return jsonData.replace(/\+/g, ' ').replace(/\\n/g, '<br>');
      }
    }

    /**
     * Truncates a description to a specified maximum length.
     * @param {string} description - The description to truncate.
     * @param {number} [maxLength=253] - The maximum length of the truncated description.
     * @returns {string} The truncated description.
     */
  }, {
    key: "truncateDescription",
    value: function truncateDescription(description) {
      var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 253;
      return description.length > maxLength ? "".concat(description.substring(0, maxLength), "...") : description;
    }

    /**
     * Appends a featured description to the compare products modal.
     * @param {string} description - The featured description to append.
     */
  }, {
    key: "appendFeaturedDescription",
    value: function appendFeaturedDescription(description, id, originalDescription) {
      var featuredDescriptionHTML = this.productFeaturedDescriptionHTMLTemplate(description, id, originalDescription);
      var comparisonFeaturedDescription = document.createElement('div');
      comparisonFeaturedDescription.classList.add('main-product-comparison__featured-description', 'd-flex', 'w-full', 'main-product-comparison__subsections--featured-description-new');
      comparisonFeaturedDescription.innerHTML = featuredDescriptionHTML;
      this.compareProductsInfo.appendChild(comparisonFeaturedDescription);
    }

    /**
     * Generates the HTML template for a featured product description.
     * @param {string} description - The description to include in the template.
     * @returns {string} The HTML template string.
     */
  }, {
    key: "productFeaturedDescriptionHTMLTemplate",
    value: function productFeaturedDescriptionHTMLTemplate(description, id, originalDescription) {
      var readMoreText = this.compareProductsModal.closest('.compare-products-modal').getAttribute('data-read-more-translation');
      var readLessText = this.compareProductsModal.closest('.compare-products-modal').getAttribute('data-read-less-translation');
      var emptyClass = '';
      if (description.length === 0) {
        emptyClass = 'hidden';
      }
      return "\n      <div class=\"product-featured-description\">\n        <div class=\"product-featured-description__content\"><div class=\"short-description\">".concat(description, "</div>\n          <a href=\"#\" class=\"product-featured-description__read-more full-unstyled-link w-full d-flex ").concat(emptyClass, "\" js-toggle-description=\"").concat(id, "\">").concat(readMoreText, "</a>\n          <div class=\"product-featured-description__full-description hidden\" js-full-description=\"").concat(id, "\">").concat(originalDescription, "</div>\n          <a href=\"#\" class=\"product-featured-description__read-less full-unstyled-link w-full d-flex hidden \" js-toggle-description=\"").concat(id, "\">").concat(readLessText, "</a>\n        </div>\n      </div>\n    ");
    }

    /**
     * Groups and structures the featured descriptions in the compare products modal.
     */
  }, {
    key: "groupDescriptions",
    value: function groupDescriptions() {
      var descriptions = document.querySelectorAll('.product-featured-description');

      // Create container for descriptions
      var descriptionContainer = this.createDescriptionContainer();

      // Create and add header
      var header = this.createDescriptionHeader();
      descriptionContainer.appendChild(header);

      // Create and add description content
      var descriptionContent = this.createDescriptionContent(descriptions);
      descriptionContainer.appendChild(descriptionContent);

      // Remove empty descriptions
      this.removeEmptyDescriptions();
    }

    /**
     * Creates and returns the main container for descriptions.
     * @returns {HTMLElement} The description container element.
     */
  }, {
    key: "createDescriptionContainer",
    value: function createDescriptionContainer() {
      // Remove any existing child element
      var existingContainers = this.compareProductsInfo.querySelectorAll('.product-featured-description-container');
      existingContainers.forEach(function (container) {
        container.remove();
      });
      var container = document.createElement('div');
      container.classList.add('product-featured-description-container', 'w-full', 'd-flex', 'flex-column');
      this.compareProductsInfo.prepend(container);
      return container;
    }

    /**
     * Creates and returns the header for the description section.
     * @returns {HTMLElement} The header element.
     */
  }, {
    key: "createDescriptionHeader",
    value: function createDescriptionHeader() {
      var header = document.createElement('div');
      header.classList.add('comparison__header');
      header.innerHTML = "\n      <h5 class=\"comparison__heading\">".concat(languageStrings.description, "</h5>\n      <div class=\"comparison__accordion-toggle\">\n        <svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <rect opacity=\"0.01\" x=\"12\" y=\"4\" width=\"1\" height=\"15\" rx=\"0.5\" fill=\"black\" stroke=\"black\" stroke-width=\"1.2\"/>\n          <rect x=\"5\" y=\"11\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\" stroke=\"black\" stroke-width=\"1.2\"/>\n        </svg>\n      </div>\n    ");
      return header;
    }

    /**
     * Creates and returns the content container for descriptions.
     * @param {NodeList} descriptions - The list of description elements to include.
     * @returns {HTMLElement} The description content container.
     */
  }, {
    key: "createDescriptionContent",
    value: function createDescriptionContent(descriptions) {
      var content = document.createElement('div');
      content.classList.add('product-featured-description__grid', 'accordion-content', 'd-flex', 'w-full', 'flex-row');
      var spacer = document.createElement('div');
      var backSpacer = document.createElement('div');
      spacer.classList.add('compare-products-modal__spacer');
      content.appendChild(spacer);
      descriptions.forEach(function (description) {
        return content.appendChild(description);
      });
      backSpacer.classList.add('compare-products-modal__back-spacer');
      content.appendChild(backSpacer);
      return content;
    }

    /**
     * Removes empty description elements from the DOM.
     */
  }, {
    key: "removeEmptyDescriptions",
    value: function removeEmptyDescriptions() {
      var emptyDescriptions = document.querySelectorAll('.main-product-comparison__featured-description');
      emptyDescriptions.forEach(function (description) {
        if (description.innerHTML === '' || description.childElementCount === 0) {
          description.remove();
        }
      });
    }
  }]);
}();
/* harmony default export */ var productDescriptionHandler = (ProductDescriptionHandler);
;// ./src/scripts/components/compareHTMLTemplates.js


/**
 * Generates HTML template for an empty slot in a product comparison modal.
 *
 * @param {string[]} vendors - Array of vendor names to be displayed in the empty slot.
 * @returns {string} HTML string for the empty slot template.
 */
var emptySlotHTMLTemplate = function emptySlotHTMLTemplate(vendors) {
  return "\n  <div class=\"compare-products-modal__empty-slot empty-slot\">\n    <div class=\"empty-slot__container\">\n      <div class=\"empty-slot__content\">\n        <div class=\"empty-slot__header\">\n          <h4 class=\"empty-slot__heading\" js-close-trigger> ".concat(languageStrings.select_another_item, " <svg width=\"22\" height=\"22\" viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <circle cx=\"11.0002\" cy=\"11.0007\" r=\"9.16667\" stroke=\"black\" stroke-width=\"1.1\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n            <path d=\"M14.6665 11.0033L7.33317 10.9993\" stroke=\"black\" stroke-width=\"1.375\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n            <path d=\"M10.9998 7.33569L10.9998 14.669\" stroke=\"black\" stroke-width=\"1.375\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n            </svg>\n          </h4>\n        </div>\n        <div class=\"empty-slot__vendors\">\n        <p class=\"empty-slot__vendors-copy\">").concat(languageStrings.or_select_from, ":</p>\n          ").concat(vendors.map(function (vendor) {
    return "\n          <div class=\"empty-slot__vendor\">\n            <h5 class=\"empty-slot__vendor-name\">\n              <a href=\"".concat(window.Shopify.routes.root, "collections/").concat(vendor.toLowerCase().replace(/\ /g, '-'), "\" aria-label=\"Select another ").concat(vendor, " item to compare\" class=\"empty-slot__vendor-link full-unstyled-link\" js-set-vendor-change>\n                ").concat(vendor, " \n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                  <path d=\"M4.66984 3.33398L9.33317 8.01865L4.6665 12.6673\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n                </svg>\n              </a>\n            </h5>\n         \n          </div>\n          ");
  }).join(''), "\n        </div>\n      </div>\n    </div>\n  </div>\n");
};

/**
 * Replaces all occurrences of '+' with a space in the given string.
 *
 * @param {string} string - The input string to process.
 * @returns {string} The processed string with '+' replaced by spaces.
 */
var replacePlusWithSpace = function replacePlusWithSpace(string) {
  return string.replace(/\+/g, ' ');
};

;// ./src/scripts/utils/error-handler.js
function error_handler_typeof(o) { "@babel/helpers - typeof"; return error_handler_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, error_handler_typeof(o); }
function error_handler_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function error_handler_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, error_handler_toPropertyKey(o.key), o); } }
function error_handler_createClass(e, r, t) { return r && error_handler_defineProperties(e.prototype, r), t && error_handler_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function error_handler_toPropertyKey(t) { var i = error_handler_toPrimitive(t, "string"); return "symbol" == error_handler_typeof(i) ? i : i + ""; }
function error_handler_toPrimitive(t, r) { if ("object" != error_handler_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != error_handler_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// utils/ErrorHandler.js
var ErrorHandler = /*#__PURE__*/function () {
  function ErrorHandler() {
    error_handler_classCallCheck(this, ErrorHandler);
  }
  return error_handler_createClass(ErrorHandler, [{
    key: "handle",
    value: function handle(error) {
      console.error('An error occurred:', error.message);
      this.showErrorMessage('An error occurred. Please try again later.');
    }
  }, {
    key: "showErrorMessage",
    value: function showErrorMessage(message) {
      var errorContainer = document.createElement('div');
      errorContainer.classList.add('error-message');
      errorContainer.textContent = message;
      document.body.appendChild(errorContainer);
      setTimeout(function () {
        errorContainer.remove();
      }, 5000);
    }
  }]);
}();
/* harmony default export */ var error_handler = (ErrorHandler);
;// ./src/scripts/ui/ui-manager-add-products.js
/**
 * @file ui-manager-add-products.js
 * @description Direct export of the optimized addProductsToComparisonModal function
 */

/**
 * Adds up to 3 products to the comparison modal
 *
 * @param {HTMLElement[]} productHTMLArray - Array of product HTML elements (maximum 3)
 */
function addProductsToComparisonModal(productHTMLArray) {
  // 'this' will be the UIManager instance when called with call()

  // Show loading spinner
  var loadingSpinner = this.modalElement.querySelector('.loading-spinner');
  if (loadingSpinner) {
    loadingSpinner.classList.add('active');
  }
  try {
    // Validate input
    if (!Array.isArray(productHTMLArray)) {
      throw new Error('Invalid productHTMLArray provided. Expected an array of HTMLElements.');
    }
    if (productHTMLArray.length > 3) {
      console.warn('More than 3 products provided. Only the first 3 will be displayed.');
      productHTMLArray = productHTMLArray.slice(0, 3);
    }

    // Get DOM containers
    var compareProductsModal = this.modalElement.querySelector('.compare-products-modal__products');
    var compareProductsModalInfo = this.modalElement.querySelector('.compare-products-modal__info');
    if (!compareProductsModal || !compareProductsModalInfo) {
      throw new Error('Compare products modal not found.');
    }

    // Clear existing content
    compareProductsModal.innerHTML = '';
    compareProductsModalInfo.innerHTML = '';

    // Add all products at once (maximum 3)
    productHTMLArray.forEach(function (productHTML) {
      // Skip invalid elements
      if (!(productHTML instanceof HTMLElement)) return;

      // Create column and append directly
      var productColumn = document.createElement('div');
      productColumn.classList.add('compare-products-modal__product');
      productColumn.appendChild(productHTML);
      compareProductsModal.appendChild(productColumn);
    });

    // Hide spinner when complete
    setTimeout(function () {
      if (loadingSpinner) loadingSpinner.classList.remove('active');
    }, 1000);
  } catch (error) {
    // Handle errors and hide spinner
    console.error('Error adding products to modal:', error);
    if (loadingSpinner) loadingSpinner.classList.remove('active');
    this.errorHandler.handle(error);
  }
}

/**
 * Utility to apply the comparison function within a UIManager class
 * @param {Object} instance - The UIManager instance
 * @param {HTMLElement[]} productHTMLArray - Array of product HTML elements (maximum 3)
 */
function compareProducts(instance, productHTMLArray) {
  addProductsToComparisonModal.call(instance, productHTMLArray);
}
;// ./src/scripts/ui/ui-manager.js
function ui_manager_typeof(o) { "@babel/helpers - typeof"; return ui_manager_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ui_manager_typeof(o); }
function ui_manager_toConsumableArray(r) { return ui_manager_arrayWithoutHoles(r) || ui_manager_iterableToArray(r) || ui_manager_unsupportedIterableToArray(r) || ui_manager_nonIterableSpread(); }
function ui_manager_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function ui_manager_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return ui_manager_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? ui_manager_arrayLikeToArray(r, a) : void 0; } }
function ui_manager_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function ui_manager_arrayWithoutHoles(r) { if (Array.isArray(r)) return ui_manager_arrayLikeToArray(r); }
function ui_manager_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ui_manager_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ ui_manager_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == ui_manager_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(ui_manager_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ui_manager_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function ui_manager_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { ui_manager_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { ui_manager_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ui_manager_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function ui_manager_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ui_manager_toPropertyKey(o.key), o); } }
function ui_manager_createClass(e, r, t) { return r && ui_manager_defineProperties(e.prototype, r), t && ui_manager_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ui_manager_toPropertyKey(t) { var i = ui_manager_toPrimitive(t, "string"); return "symbol" == ui_manager_typeof(i) ? i : i + ""; }
function ui_manager_toPrimitive(t, r) { if ("object" != ui_manager_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ui_manager_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @file UIManager.js
 * @description Manages the UI components and interactions for the product comparison modal.
 */








// Define selectors for DOM elements
var SELECTORS = {
  compareProductsModal: '.compare-products-modal__products',
  compareProductsModalInfo: '.compare-products-modal__info',
  productHighlight: '.product-highlight',
  altCardShopNow: '.alt-card__shop-now',
  mainProductComparisonSubsections: '.main-product-comparison__subsections--new',
  closeTrigger: '[js-close-trigger]',
  accordionToggle: '.comparison__accordion-toggle',
  previousButton: '[js-previous]',
  nextButton: '[js-next]',
  cardMedia: '.card .media [js-media]',
  multiImageButtons: '.multi-image__buttons',
  compareProductsInfo: '.compare-products-modal__info',
  loadingSpinner: '.loading-spinner',
  vendorChange: '[js-set-vendor-change]'
};

/**
 * @class UIManager
 * @description Manages the UI for the product comparison modal, including product data processing,
 * empty slot handling, and UI interactions.
 */
var UIManager = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {HTMLElement} modalElement - The root element of the comparison modal
   */
  function UIManager(modalElement) {
    ui_manager_classCallCheck(this, UIManager);
    this.modalElement = modalElement;
    this.productHighlights = new getProductHighlights(SELECTORS.compareProductsModal, SELECTORS.compareProductsInfo);
    this.productDescriptionHandler = new productDescriptionHandler(SELECTORS.compareProductsModal, SELECTORS.compareProductsInfo);
    this.productDataHandler = new productDataHandler(this.modalElement);
    this.productService = this.modalElement.productService;
    this.errorHandler = new error_handler();
  }

  /**
   * @method processProductData
   * @description Processes product data and populates the modal with product information
   * @param {Array<HTMLElement>} productHTMLArray - Array of product HTML elements
   * @param {Array<Object>} products - Array of product data objects
   * @param {Array<Object>} productInfo - Array of product info objects
   */
  return ui_manager_createClass(UIManager, [{
    key: "processProductData",
    value: function processProductData(productHTMLArray, products, productInfo) {
      try {
        // Use the direct function approach with call()
        compareProducts(this, productHTMLArray);
      } catch (error) {
        console.error('Error adding products to modal', error);
        this.errorHandler.handle(error);
      }
      var productIds = productInfo.map(function (product) {
        return product.id;
      });
      this.productIds = productIds;
      try {
        this.productHighlights.getProductHighlights(productHTMLArray);
      } catch (error) {
        console.error('Error finding product highlights', error);
        this.errorHandler.handle(error);
      }
      try {
        this.productDescriptionHandler.getProductFeaturedDescriptionData(productHTMLArray);
      } catch (error) {
        console.error('Error finding product featured description data', error);
        this.errorHandler.handle(error);
      }
      try {
        this.productDataHandler.getProductDataHTML(productHTMLArray, productHTMLArray.length, this.productIds, products);
      } catch (error) {
        console.error('Error finding product data HTML', error);
        this.errorHandler.handle(error);
      }
    }

    /**
     * @method handleEmptyHighlights
     * @description Removes empty product highlight elements from the modal
     */
  }, {
    key: "handleEmptyHighlights",
    value: function handleEmptyHighlights() {
      var emptyHighlights = this.modalElement.querySelectorAll(SELECTORS.productHighlight);
      emptyHighlights.forEach(function (highlight) {
        if (!highlight.innerHTML.trim() || highlight.childElementCount === 0) {
          highlight.remove();
        }
      });
    }

    /**
     * @method handleEmptySlots
     * @description Handles empty slots in the comparison modal by fetching and rendering related products
     * @param {Array<HTMLElement>} productHTMLArray - Array of product HTML elements
     * @returns {Promise<void>}
     */
  }, {
    key: "handleEmptySlots",
    value: (function () {
      var _handleEmptySlots = ui_manager_asyncToGenerator(/*#__PURE__*/ui_manager_regeneratorRuntime().mark(function _callee(productHTMLArray) {
        var totalSlots, productIds, products, mergedResults, uniqueVendors, newVendors;
        return ui_manager_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              totalSlots = this.getTotalSlots();
              if (!(productHTMLArray.length >= totalSlots)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.prev = 3;
              productIds = productHTMLArray.map(function (product) {
                return product.id;
              });
              _context.next = 7;
              return this.productService.fetchRelatedProducts(productIds);
            case 7:
              products = _context.sent;
              mergedResults = this.productService.mergeDuplicateProducts(products);
              uniqueVendors = this.productService.extractUniqueVendors(mergedResults);
              newVendors = this.productService.filterNewVendors(uniqueVendors);
              this.renderEmptySlot(newVendors);
              this.setupCloseButtons();
              this.setupVendorChangeEventListeners();
              _context.next = 20;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](3);
              console.error('Error handling empty slots:', _context.t0);
              this.errorHandler.handle(_context.t0);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 16]]);
      }));
      function handleEmptySlots(_x) {
        return _handleEmptySlots.apply(this, arguments);
      }
      return handleEmptySlots;
    }()
    /**
     * @method setupVendorChangeEventListeners
     * @description Sets up event listeners for vendor change
     */
    )
  }, {
    key: "setupVendorChangeEventListeners",
    value: function setupVendorChangeEventListeners() {
      var _this = this;
      this.modalElement.querySelectorAll(SELECTORS.vendorChange).forEach(function (vendorChange) {
        vendorChange.addEventListener('click', function (e) {
          return _this.handleVendorChange(vendorChange, e);
        });
      });
    }

    /**
     * @method handleVendorChange
     * @description Handles vendor change
     * @param {HTMLElement} vendorChange - The vendor change element
     */
  }, {
    key: "handleVendorChange",
    value: function handleVendorChange(vendorChange, e) {
      e.preventDefault();

      /* Set session storage where 'compare-vendor-switched' is true */
      sessionStorage.setItem('compare-vendor-switched', 'true');
      /* Redirect to the vendor page */
      window.location.href = vendorChange.href;
    }

    /**
     * @method setupUIInteractions
     * @description Sets up various UI interactions for the comparison modal
     */
  }, {
    key: "setupUIInteractions",
    value: function setupUIInteractions() {
      this.duplicateShopNowButtons();
      this.setToggleEventListeners();
      this.setupPrevNextButtons();
      this.initializePrevNextButtons();
    }
  }, {
    key: "activateLoadingSpinner",
    value: function activateLoadingSpinner() {
      var loadingSpinner = this.modalElement.querySelector(SELECTORS.loadingSpinner);
      if (loadingSpinner) {
        loadingSpinner.classList.remove('hidden');
      }
    }

    /**
     * @method duplicateShopNowButtons
     * @description Duplicates "Shop Now" buttons and appends them to the modal
     */
  }, {
    key: "duplicateShopNowButtons",
    value: function duplicateShopNowButtons() {
      var shopNowButtons = Array.from(this.modalElement.querySelectorAll(SELECTORS.altCardShopNow));
      if (shopNowButtons.length === 0) return;
      var newButtons = shopNowButtons.map(function (button) {
        return button.cloneNode(true);
      });
      var compareProductsModal = this.modalElement.querySelector(SELECTORS.compareProductsModal);
      var lastSubsection = compareProductsModal.querySelector(SELECTORS.mainProductComparisonSubsections);
      var buttonContainer = document.createElement('div');
      buttonContainer.classList.add('shop-now-button-container');
      newButtons.forEach(function (button) {
        buttonContainer.appendChild(button);
      });
      compareProductsModal.insertBefore(buttonContainer, lastSubsection.nextSibling);
    }

    /**
     * @method renderEmptySlot
     * @description Renders an empty slot in the comparison modal with new vendor information
     * @param {Array<string>} newVendors - Array of new vendor names
     */
  }, {
    key: "renderEmptySlot",
    value: function renderEmptySlot(newVendors) {
      var compareProductsModal = this.modalElement.querySelector(SELECTORS.compareProductsModal);
      var emptySlot = document.createElement('div');
      emptySlot.classList.add('compare-products-modal__product');
      emptySlot.classList.add('empty-slot__product');
      emptySlot.innerHTML = emptySlotHTMLTemplate(newVendors);
      var highlightsElement = compareProductsModal.querySelector('.main-product-comparison__highlights');
      var existingEmptySlot = document.querySelector('.compare-products-modal__product.empty-slot__product');
      var productElements = document.querySelectorAll('.compare-products-modal__products .compare-products-modal__product');
      if (!existingEmptySlot && productElements.length < 3) {
        compareProductsModal.insertBefore(emptySlot, highlightsElement);
      }
    }

    /**
     * @method setupCloseButtons
     * @description Sets up event listeners for close buttons in the modal
     */
  }, {
    key: "setupCloseButtons",
    value: function setupCloseButtons() {
      var _this2 = this;
      this.modalElement.querySelectorAll(SELECTORS.closeTrigger).forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
          _this2.modalElement.closeModal();
        });
      });
    }

    /**
     * @method setToggleEventListeners
     * @description Sets up event listeners for accordion toggles in the modal
     */
  }, {
    key: "setToggleEventListeners",
    value: function setToggleEventListeners() {
      var _this3 = this;
      ui_manager_toConsumableArray(this.modalElement.querySelectorAll(SELECTORS.accordionToggle)).forEach(function (toggle) {
        toggle.addEventListener('click', function (e) {
          return _this3.toggleAccordion(toggle, e);
        });
        toggle.parentElement.addEventListener('click', function (e) {
          return _this3.toggleAccordion(toggle, e);
        });
      });
    }

    /**
     * @method toggleAccordion
     * @description Toggles the visibility of an accordion content and updates the icon
     * @param {HTMLElement} toggle - The accordion toggle element
     */
  }, {
    key: "toggleAccordion",
    value: function toggleAccordion(toggle, e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var parent = toggle.parentElement.parentElement;
      var content = parent.querySelector('.accordion-content');
      if (content) {
        content.classList.toggle('hidden');
      }
      var svgIcon = toggle.querySelector('svg');
      if (svgIcon) {
        svgIcon.classList.toggle('active');
      }
    }

    /**
     * @method setupPrevNextButtons
     * @description Sets up previous and next buttons for product images
     */
  }, {
    key: "setupPrevNextButtons",
    value: function setupPrevNextButtons() {
      var _this4 = this;
      var observer = new MutationObserver(function (mutations, obs) {
        if (_this4.modalElement.querySelectorAll(SELECTORS.previousButton).length > 0 && _this4.modalElement.querySelectorAll(SELECTORS.nextButton).length > 0) {
          obs.disconnect();
          _this4.initializePrevNextButtons();
        }
      });
      observer.observe(this.modalElement, {
        childList: true,
        subtree: true
      });
    }

    /**
     * @method initializePrevNextButtons
     * @description Initializes event listeners for previous and next buttons
     */
  }, {
    key: "initializePrevNextButtons",
    value: function initializePrevNextButtons() {
      var _this5 = this;
      ui_manager_toConsumableArray(this.modalElement.querySelectorAll(SELECTORS.previousButton)).forEach(function (el) {
        el.addEventListener('click', function (e) {
          return _this5.handlePrevNextClick(e, el, -1);
        });
      });
      ui_manager_toConsumableArray(this.modalElement.querySelectorAll(SELECTORS.nextButton)).forEach(function (el) {
        el.addEventListener('click', function (e) {
          return _this5.handlePrevNextClick(e, el, 1);
        });
      });
    }

    /**
     * @method handlePrevNextClick
     * @description Handles clicks on previous and next buttons for product images
     * @param {Event} event - The click event
     * @param {HTMLElement} el - The clicked button element
     * @param {number} direction - The direction to move (-1 for previous, 1 for next)
     */
  }, {
    key: "handlePrevNextClick",
    value: function handlePrevNextClick(event, el, direction) {
      event.preventDefault();
      var images = this.getImages(el);
      var currentIndex = this.getCurrentIndex(images);
      var newIndex = currentIndex + direction;
      if (newIndex >= 0 && newIndex < images.length) {
        this.moveToIndex(images, currentIndex, newIndex, el);
      }
    }

    /**
     * @method getImages
     * @description Gets all image elements for a product card
     * @param {HTMLElement} el - The button element
     * @returns {NodeList} - NodeList of image elements
     */
  }, {
    key: "getImages",
    value: function getImages(el) {
      return el.closest('.card').querySelectorAll(SELECTORS.cardMedia);
    }

    /**
     * @method getCurrentIndex
     * @description Gets the index of the currently visible image
     * @param {NodeList} images - NodeList of image elements
     * @returns {number} - Index of the currently visible image
     */
  }, {
    key: "getCurrentIndex",
    value: function getCurrentIndex(images) {
      return Array.from(images).findIndex(function (img) {
        return !img.classList.contains('hidden');
      });
    }

    /**
     * @method moveToIndex
     * @description Moves the product images to a new index
     * @param {NodeList} images - NodeList of image elements
     * @param {number} currentIndex - The current image index
     * @param {number} newIndex - The new image index
     * @param {HTMLElement} el - The clicked button element
     */
  }, {
    key: "moveToIndex",
    value: function moveToIndex(images, currentIndex, newIndex, el) {
      images[currentIndex].classList.add('hidden');
      images[newIndex].classList.remove('hidden');
      this.updateButtonStates(images, newIndex, el);
    }

    /**
     * @method updateButtonStates
     * @description Updates the disabled state of previous and next buttons
     * @param {NodeList} images - NodeList of image elements
     * @param {number} newIndex - The new image index
     * @param {HTMLElement} el - The clicked button element
     */
  }, {
    key: "updateButtonStates",
    value: function updateButtonStates(images, newIndex, el) {
      var multiImageButtons = el.closest(SELECTORS.multiImageButtons);
      var prevButton = multiImageButtons.querySelector(SELECTORS.previousButton);
      var nextButton = multiImageButtons.querySelector(SELECTORS.nextButton);
      prevButton.disabled = newIndex === 0;
      nextButton.disabled = newIndex === images.length - 1;
    }

    /**
     * @method getTotalSlots
     * @description Gets the total number of product slots based on screen size
     * @returns {number} - Total number of product slots
     */
  }, {
    key: "getTotalSlots",
    value: function getTotalSlots() {
      return window.matchMedia('(max-width: 991px)').matches ? 2 : 3;
    }
  }]);
}();
/* harmony default export */ var ui_manager = (UIManager);
;// ./src/scripts/services/state-manager.js
function state_manager_typeof(o) { "@babel/helpers - typeof"; return state_manager_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, state_manager_typeof(o); }
function state_manager_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ state_manager_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == state_manager_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(state_manager_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function state_manager_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function state_manager_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { state_manager_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { state_manager_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function state_manager_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function state_manager_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, state_manager_toPropertyKey(o.key), o); } }
function state_manager_createClass(e, r, t) { return r && state_manager_defineProperties(e.prototype, r), t && state_manager_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function state_manager_toPropertyKey(t) { var i = state_manager_toPrimitive(t, "string"); return "symbol" == state_manager_typeof(i) ? i : i + ""; }
function state_manager_toPrimitive(t, r) { if ("object" != state_manager_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != state_manager_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Manages the state of products in session storage, including loading, adding, and removing products.
 */
var StateManager = /*#__PURE__*/function () {
  /**
   * Creates an instance of StateManager.
   * @param {string} storageKey - The key used to store product handles in sessionStorage.
   * @param {number} maxProducts - The maximum number of products allowed on desktop.
   * @param {number} maxMobileProducts - The maximum number of products allowed on mobile.
   */
  function StateManager(storageKey, maxProducts, maxMobileProducts) {
    state_manager_classCallCheck(this, StateManager);
    this.storageKey = storageKey;
    this.maxProducts = maxProducts;
    this.maxMobileProducts = maxMobileProducts;
  }

  /**
   * Loads products from sessionStorage and fetches their data.
   * @returns {Promise<Array<Object>>} - An array of product data objects.
   */
  return state_manager_createClass(StateManager, [{
    key: "loadProducts",
    value: (function () {
      var _loadProducts = state_manager_asyncToGenerator(/*#__PURE__*/state_manager_regeneratorRuntime().mark(function _callee() {
        var storedProducts, compareProductsExpiration, isMobile, products, filteredProducts;
        return state_manager_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Retrieve stored product handles from sessionStorage.
              storedProducts = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
              /* Check for compare_products_expiration value in local storage */
              compareProductsExpiration = localStorage.getItem('compare_products_expiration');
              /* If the compare_products_expiration value (datetime) is in the past and exists, clear the stored products */
              if (compareProductsExpiration && new Date(compareProductsExpiration) < new Date()) {
                localStorage.removeItem(this.storageKey);
                storedProducts = [];
                localStorage.removeItem('compare_products_expiration');
              }
              isMobile = window.matchMedia('(max-width: 991px)').matches;
              if (isMobile && storedProducts.length > this.maxMobileProducts) {
                storedProducts = storedProducts.slice(0, this.maxMobileProducts);
                /* Remove the last product from the session storage */
                localStorage.setItem(this.storageKey, JSON.stringify(storedProducts));
                /* Set the compare_products_expiration value to 1 day from now */
                localStorage.setItem('compare_products_expiration', new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString());
              }
              // Fetch product data for each handle in parallel.
              _context.next = 7;
              return Promise.all(storedProducts.map(this.fetchProduct));
            case 7:
              products = _context.sent;
              // Filter out any products that failed to fetch (null).
              filteredProducts = products.filter(function (product) {
                return product !== null;
              });
              return _context.abrupt("return", filteredProducts);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadProducts() {
        return _loadProducts.apply(this, arguments);
      }
      return loadProducts;
    }()
    /**
     * Fetches product data from the server using the product handle.
     * @param {string} handle - The product handle.
     * @returns {Promise<Object|null>} - The product data object or null if fetching failed.
     */
    )
  }, {
    key: "fetchProduct",
    value: (function () {
      var _fetchProduct = state_manager_asyncToGenerator(/*#__PURE__*/state_manager_regeneratorRuntime().mark(function _callee2(handle) {
        var response;
        return state_manager_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return fetch("".concat(window.Shopify.routes.root, "products/").concat(handle, ".js"));
            case 3:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 6;
                break;
              }
              throw new Error("HTTP error! status: ".concat(response.status));
            case 6:
              _context2.next = 8;
              return response.json();
            case 8:
              return _context2.abrupt("return", _context2.sent);
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              // Log the error and return null to indicate failure.
              console.error("Error fetching product ".concat(handle, ":"), _context2.t0);
              return _context2.abrupt("return", null);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 11]]);
      }));
      function fetchProduct(_x) {
        return _fetchProduct.apply(this, arguments);
      }
      return fetchProduct;
    }()
    /**
     * Checks if a new product can be added based on the current count and device type.
     * @returns {boolean} - True if a product can be added, false otherwise.
     */
    )
  }, {
    key: "canAddProduct",
    value: function canAddProduct(handle) {
      // Determine if the user is on a mobile device.
      var isMobile = window.matchMedia('(max-width: 991px)').matches;
      /* Check the product type of the product with the handle */
      var productType = this.fetchProduct(handle).product_type;
      return isMobile ? this.getStoredProductHandles().length < this.maxMobileProducts : this.getStoredProductHandles().length < this.maxProducts;
    }

    /**
     * Adds a product by handle if possible.
     * @param {string} handle - The product handle to add.
     * @returns {Promise<Object|null>} - The added product data or null if addition failed.
     */
  }, {
    key: "addProduct",
    value: (function () {
      var _addProduct = state_manager_asyncToGenerator(/*#__PURE__*/state_manager_regeneratorRuntime().mark(function _callee3(handle) {
        var product, handles, productType;
        return state_manager_regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.canAddProduct(handle)) {
                _context3.next = 10;
                break;
              }
              _context3.next = 3;
              return this.fetchProduct(handle);
            case 3:
              product = _context3.sent;
              if (!product) {
                _context3.next = 10;
                break;
              }
              // Get the current list of stored product handles.
              handles = this.getStoredProductHandles();
              productType = product.product_type; // Add the new handle to the list.
              handles.push(handle);

              // Update the stored product handles in sessionStorage.
              this.updateStoredProductHandles(handles);

              // Return the product data.
              return _context3.abrupt("return", product);
            case 10:
              return _context3.abrupt("return", null);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function addProduct(_x2) {
        return _addProduct.apply(this, arguments);
      }
      return addProduct;
    }()
    /**
     * Removes a product from the stored handles by index.
     * @param {number} index - The index of the product to remove.
     */
    )
  }, {
    key: "removeProduct",
    value: function removeProduct(index) {
      // Get the current list of stored product handles.
      var handles = this.getStoredProductHandles();

      // Remove the handle at the specified index.
      handles.splice(index, 1);

      // Update the stored product handles in sessionStorage.
      this.updateStoredProductHandles(handles);
    }

    /**
     * Retrieves the list of stored product handles from sessionStorage.
     * @returns {Array<string>} - An array of product handles.
     */
  }, {
    key: "getStoredProductHandles",
    value: function getStoredProductHandles() {
      // Parse and return the stored product handles from sessionStorage.
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    }

    /**
     * Updates the stored product handles in sessionStorage.
     * @param {Array<string>} handles - The array of product handles to store.
     */
  }, {
    key: "updateStoredProductHandles",
    value: function updateStoredProductHandles(handles) {
      // Stringify and store the product handles in sessionStorage.
      localStorage.setItem(this.storageKey, JSON.stringify(handles));
      /* Set the compare_products_expiration value to 1 day from now, if it doesn't exist */
      if (!localStorage.getItem('compare_products_expiration')) {
        localStorage.setItem('compare_products_expiration', new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString());
      }
    }
  }]);
}();
/* harmony default export */ var state_manager = (StateManager);
;// ./src/scripts/utils/event-manager.js
function event_manager_typeof(o) { "@babel/helpers - typeof"; return event_manager_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, event_manager_typeof(o); }
function event_manager_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ event_manager_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == event_manager_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(event_manager_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function event_manager_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function event_manager_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { event_manager_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { event_manager_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function event_manager_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function event_manager_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, event_manager_toPropertyKey(o.key), o); } }
function event_manager_createClass(e, r, t) { return r && event_manager_defineProperties(e.prototype, r), t && event_manager_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function event_manager_defineProperty(e, r, t) { return (r = event_manager_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function event_manager_toPropertyKey(t) { var i = event_manager_toPrimitive(t, "string"); return "symbol" == event_manager_typeof(i) ? i : i + ""; }
function event_manager_toPrimitive(t, r) { if ("object" != event_manager_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != event_manager_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class EventManager
 * @description Manages event listeners for a modal element and handles product comparison functionality.
 */


var EventManager = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Element} modalElement - The DOM element representing the modal.
   * @throws {Error} If modalElement is not a valid DOM element.
   */
  function EventManager(modalElement, _productsState) {
    var _this = this;
    event_manager_classCallCheck(this, EventManager);
    event_manager_defineProperty(this, "updateProductsState", function (productsState) {
      _this.productsState = productsState;
    });
    /**
     * @method setupEventListeners
     * @description Sets up close and remove button listeners.
     */
    event_manager_defineProperty(this, "setupEventListeners", function () {
      _this.setupCloseButtonListeners();
      _this.setupRemoveButtonListeners();
    });
    event_manager_defineProperty(this, "toggleBodyNoScroll", function () {
      document.body.classList.toggle('no-scroll', _this.modalElement.classList.contains('compare-products-modal--open'));
      // document.body.classList.toggle('no-scroll', this.modalElement.classList.contains('compare-products-modal--open'));
    });
    /**
     * @method setupCompareProductsModalOpenedListener
     * @description Sets up a listener for the compareProductsModalOpened event.
     */
    event_manager_defineProperty(this, "setupCompareProductsModalOpenedListener", function () {
      document.addEventListener('compareProductsModalOpened', function () {
        var hands = _this.stateManager.getStoredProductHandles();
        _this.toggleBodyNoScroll();
        if (!_this.productsState.every(function (v, i) {
          return v === hands[i];
        })) {
          if (typeof _this.modalElement.initializeModal === 'function') {
            _this.modalElement.initializeModal('compareProductsModalOpened event listener').then(function () {
              _this.setupEventListeners();
            }).catch(function (error) {
              console.error('Error initializing modal:', error);
              if (_this.errorHandler && typeof _this.errorHandler.handle === 'function') {
                _this.errorHandler.handle(error);
              }
            });
          } else {
            console.error('initializeModal is not a function on modalElement');
          }
        } else {
          _this.setupEventListeners();
        }
      });
    });
    /**
     * @method setupCloseButtonListeners
     * @description Sets up listeners for close buttons in the modal.
     */
    event_manager_defineProperty(this, "setupCloseButtonListeners", function () {
      var closeButtons = _this.modalElement.querySelectorAll('[js-close-compare]');
      closeButtons.forEach(function (close) {
        return _this.addEventListenerWithRemoval(close, 'click', function () {
          if (typeof _this.modalElement.closeModal === 'function') {
            _this.modalElement.closeModal();
          } else {
            console.error('closeModal is not a function on modalElement');
          }
        });
      });
    });
    /**
     * @method setupCompareProductsUpdatedListener
     * @async
     * @description Sets up a listener for the compareProductsUpdated event.
     */
    event_manager_defineProperty(this, "setupCompareProductsUpdatedListener", /*#__PURE__*/event_manager_asyncToGenerator(/*#__PURE__*/event_manager_regeneratorRuntime().mark(function _callee() {
      return event_manager_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.addEventListenerWithRemoval(document, 'compareProductsUpdated', function (e) {
              if (typeof _this.modalElement.initializeModal === 'function') {
                _this.modalElement.initializeModal('compareProductsUpdated event listener').then(function () {
                  _this.setupEventListeners();
                }).catch(function (error) {
                  console.error('Error initializing modal:', error);
                  if (_this.errorHandler && typeof _this.errorHandler.handle === 'function') {
                    _this.errorHandler.handle(error);
                  }
                });
              } else {
                console.error('initializeModal is not a function on modalElement');
              }
            });
            _this.addEventListenerWithRemoval(document, 'compareProductsUpdatedDrawer', function (e) {
              if (typeof _this.modalElement.initializeModal === 'function') {} else {
                console.error('renderProducts is not a function on modalElement');
              }
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    /**
     * @method setupRemoveButtonListeners
     * @description Sets up listeners for remove buttons in the modal.
     */
    event_manager_defineProperty(this, "setupRemoveButtonListeners", function () {
      var removeButtons = _this.modalElement.querySelectorAll('[data-action="remove"]');
      removeButtons.forEach(function (removeButton) {
        _this.addEventListenerWithRemoval(removeButton, 'click', function (e) {
          e.preventDefault();
          var productHandle = removeButton.getAttribute('data-product-handle');
          if (!productHandle) {
            console.error('Product handle is missing');
            return;
          }
          try {
            // Update the compare products in session storage
            var products = JSON.parse(localStorage.getItem('compare_products') || '[]');
            var updatedProducts = products.filter(function (product) {
              return product !== productHandle;
            });
            localStorage.setItem('compare_products', JSON.stringify(updatedProducts));

            /* Check if the compare_products_expiration value is in the past */
            var compareProductsExpiration = localStorage.getItem('compare_products_expiration');
            if (compareProductsExpiration && new Date(compareProductsExpiration) < new Date()) {
              localStorage.removeItem('compare_products');
              localStorage.removeItem('compare_products_expiration');
            }

            // Dispatch event to notify of the update

            document.dispatchEvent(new CustomEvent('compareProductsUpdated'), {
              bubbles: false
            });
          } catch (error) {
            console.error('Error updating compare products:', error);
          }
        });
      });
    });
    /**
     * @method addEventListenerWithRemoval
     * @param {EventTarget} element - The element to attach the event listener to.
     * @param {string} eventType - The type of event to listen for.
     * @param {Function} listener - The callback function to execute when the event occurs.
     * @description Adds an event listener to an element and stores it for later removal.
     */
    event_manager_defineProperty(this, "addEventListenerWithRemoval", function (element, eventType, listener) {
      if (!(element instanceof EventTarget)) {
        console.error('Invalid element for event listener');
        return;
      }

      // Initialize WeakMap for the element if it doesn't exist
      if (!_this.boundEventListeners.has(element)) {
        _this.boundEventListeners.set(element, new Map());
      }
      var eventTypeListeners = _this.boundEventListeners.get(element);

      // Remove existing listener for the event type if it exists
      if (eventTypeListeners.has(eventType)) {
        var oldListener = eventTypeListeners.get(eventType);
        element.removeEventListener(eventType, oldListener);
      }

      // Add new listener and store it in the WeakMap
      element.addEventListener(eventType, listener, {
        bubbles: false
      });
      eventTypeListeners.set(eventType, listener);
    });
    /**
     * @method cleanup
     * @description Removes all event listeners that were added by this EventManager instance.
     */
    event_manager_defineProperty(this, "cleanup", function () {
      _this.boundEventListeners.forEach(function (eventTypeListeners, element) {
        eventTypeListeners.forEach(function (listener, eventType) {
          element.removeEventListener(eventType, listener);
        });
      });
      _this.boundEventListeners.clear();
    });
    if (!(modalElement instanceof Element)) {
      throw new Error('modalElement must be a valid DOM element');
    }
    this.modalElement = modalElement;

    // WeakMap to store bound event listeners for easy removal
    this.boundEventListeners = new WeakMap();
    this.stateManager = new state_manager('compare_products', 3, 2);
    this.productsState = _productsState;
    this.initialize();
  }
  return event_manager_createClass(EventManager, [{
    key: "initialize",
    value: (
    /**
     * @async
     * @method initialize
     * @description Initializes the EventManager by setting up necessary event listeners.
     */
    function () {
      var _initialize = event_manager_asyncToGenerator(/*#__PURE__*/event_manager_regeneratorRuntime().mark(function _callee2() {
        return event_manager_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.setupCompareProductsUpdatedListener();
            case 2:
              this.setupCompareProductsModalOpenedListener();
              this.setupEventListeners();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }())
  }]);
}();
/* harmony default export */ var event_manager = (EventManager);
;// ./src/scripts/utils/debounce.js
var Debounce = function Debounce(fn, delay) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return fn.apply(context, args);
    }, delay);
  };
};
var debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

;// ./src/scripts/sections/compare-products-modal.js
function compare_products_modal_typeof(o) { "@babel/helpers - typeof"; return compare_products_modal_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, compare_products_modal_typeof(o); }
function compare_products_modal_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ compare_products_modal_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == compare_products_modal_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(compare_products_modal_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function compare_products_modal_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function compare_products_modal_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { compare_products_modal_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { compare_products_modal_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function compare_products_modal_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function compare_products_modal_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, compare_products_modal_toPropertyKey(o.key), o); } }
function compare_products_modal_createClass(e, r, t) { return r && compare_products_modal_defineProperties(e.prototype, r), t && compare_products_modal_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function compare_products_modal_toPropertyKey(t) { var i = compare_products_modal_toPrimitive(t, "string"); return "symbol" == compare_products_modal_typeof(i) ? i : i + ""; }
function compare_products_modal_toPrimitive(t, r) { if ("object" != compare_products_modal_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != compare_products_modal_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == compare_products_modal_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
// CompareProductsModal.js






/**
 * @class CompareProductsModal
 * @extends HTMLElement
 * @description Custom element for a modal that compares products
 */
var CompareProductsModal = /*#__PURE__*/function (_HTMLElement) {
  /**
   * @constructor
   * @description Initialize the CompareProductsModal with necessary services and managers
   */
  function CompareProductsModal() {
    var _this;
    compare_products_modal_classCallCheck(this, CompareProductsModal);
    _this = _callSuper(this, CompareProductsModal);
    _this.updateAttributes();
    _this.isInitializing = false;
    return _this;
  }
  _inherits(CompareProductsModal, _HTMLElement);
  return compare_products_modal_createClass(CompareProductsModal, [{
    key: "updateAttributes",
    value: function updateAttributes() {
      this.productsState = [];
      /** @property {number} maxProducts - Maximum number of products that can be compared */
      this.maxProducts = 3;
      /** @property {ProductService} productService - Service for handling product-related operations */
      this.productService = new product_service();
      /** @property {UIManager} uiManager - Manager for handling UI-related operations */
      this.uiManager = new ui_manager(this);
      /** @property {EventManager} eventManager - Manager for handling event-related operations */
      this.eventManager = new event_manager(this, this.productsState);
      /** @property {ErrorHandler} errorHandler - Handler for managing errors */
      this.errorHandler = new error_handler();
    }

    /**
     * @method connectedCallback
     * @description Lifecycle method called when the element is added to the DOM
     */
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.isInitializing = true;
      this.initializeModal('connectedCallback').then(function () {
        _this2.isInitializing = false;
      }).catch(function (error) {
        _this2.errorHandler.handle(error);
      });
      this.resizeEventListener();
    }

    /**
     * @method resizeEventListener
     * @description Adds a resize event listener to the window
     */
  }, {
    key: "resizeEventListener",
    value: function resizeEventListener() {
      var _this3 = this;
      window.addEventListener('resize', Debounce(function () {
        // Prevent multiple initializations
        if (_this3.isInitializing) return;
        _this3.isInitializing = true;

        // Re-initialize the modal
        _this3.initializeModal('resizeEventListener').then(function () {
          // Only update attributes if products have changed
          _this3.isInitializing = false;
        }).catch(function (error) {
          _this3.errorHandler.handle(error);
        });
      }, 100));
    }

    /**
     * @method disconnectedCallback
     * @description Lifecycle method called when the element is removed from the DOM
     */
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {}

    /**
     * @method getNewProducts
     * @description Gets the new products
     * @returns {Array} The new products
     */
  }, {
    key: "getNewProducts",
    value: function getNewProducts() {
      var _this4 = this;
      return this.productsState.filter(function (product) {
        return !_this4.productService.getProductsFromSessionStorage().includes(product.id);
      });
    }

    /**
     * @method initializeModal
     * @description Asynchronously initializes the modal with product data and UI setup
     * @returns {Promise<void>} A promise that resolves when initialization is complete
     */
  }, {
    key: "initializeModal",
    value: (function () {
      var _initializeModal = compare_products_modal_asyncToGenerator(/*#__PURE__*/compare_products_modal_regeneratorRuntime().mark(function _callee2() {
        var _this5 = this;
        var source,
          _args2 = arguments;
        return compare_products_modal_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              source = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 'initializeModal';
              return _context2.abrupt("return", new Promise(/*#__PURE__*/function () {
                var _ref = compare_products_modal_asyncToGenerator(/*#__PURE__*/compare_products_modal_regeneratorRuntime().mark(function _callee(resolve, reject) {
                  var sameProducts, products, productsState, productsArray, compareProductsExpiration, newProducts, productHTMLArray, newProd;
                  return compare_products_modal_regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        sameProducts = false; // Retrieve products from session storage
                        products = _this5.productService.getProductsFromSessionStorage();
                        /* check if this.productsState is not empty, and if true then check if the items in the array are the same as the products array and if so, return */
                        if (_this5.productsState.length > 0) {
                          productsState = _this5.productsState.map(function (item) {
                            return item.id;
                          });
                          productsArray = products.map(function (item) {
                            return item.id;
                          });
                          if (JSON.stringify(productsState) === JSON.stringify(productsArray)) {
                            sameProducts = true;
                          }
                        }
                        if (!sameProducts) {
                          _context.next = 7;
                          break;
                        }
                        resolve();
                        return _context.abrupt("return");
                      case 7:
                        _this5.productsState = products;

                        /* Check if the compare_products_expiration value is in the past */
                        compareProductsExpiration = localStorage.getItem('compare_products_expiration');
                        if (compareProductsExpiration && new Date(compareProductsExpiration) < new Date()) {
                          localStorage.removeItem('compare_products');
                          localStorage.removeItem('compare_products_expiration');
                        }
                        if (!compareProductsExpiration) {
                          localStorage.setItem('compare_products_expiration', new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString());
                        }
                        newProducts = _this5.getNewProducts(); // Fetch detailed product information
                        _context.next = 14;
                        return _this5.productService.fetchProductInfo(products);
                      case 14:
                        productHTMLArray = _context.sent;
                        // Extract comparison elements from product info
                        newProd = productHTMLArray.map(function (info) {
                          return info.comparisonElement;
                        }); // Process product data and update UI
                        _this5.uiManager.processProductData(newProd, products, productHTMLArray, newProducts);
                        _this5.uiManager.handleEmptyHighlights();
                        _this5.uiManager.handleEmptySlots(productHTMLArray);
                        _this5.uiManager.setupUIInteractions();

                        // Update the number of products in the dataset
                        _this5.dataset.numberOfProducts = productHTMLArray.length;
                        _this5.eventManager.updateProductsState(_this5.productsState);
                        _this5.checkSessionStorageForVendorChange();
                        resolve(); // Resolve the promise when all operations are complete
                        _context.next = 30;
                        break;
                      case 26:
                        _context.prev = 26;
                        _context.t0 = _context["catch"](0);
                        _this5.errorHandler.handle(_context.t0);
                        reject(_context.t0); // Reject the promise if an error occurs
                      case 30:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[0, 26]]);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function initializeModal() {
        return _initializeModal.apply(this, arguments);
      }
      return initializeModal;
    }()
    /**
     * @method checkSessionStorageForVendorChange
     * @description Checks session storage for vendor change
     */
    )
  }, {
    key: "checkSessionStorageForVendorChange",
    value: function checkSessionStorageForVendorChange() {
      var compareVendorSwitched = Boolean(sessionStorage.getItem('compare-vendor-switched'));
      if (compareVendorSwitched) {
        setTimeout(function () {
          document.querySelector('[js-show-compare]').dispatchEvent(new CustomEvent('click', {
            bubbles: true,
            detail: {
              vendor: 'changed'
            }
          }));
          sessionStorage.removeItem('compare-vendor-switched');
        }, 1000);
      }
    }

    /**
     * @method closeModal
     * @description Toggles the visibility of the modal
     */
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.classList.toggle('compare-products-modal--open');
      document.body.classList.toggle('no-scroll', this.classList.contains('compare-products-modal--open'));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the custom element
customElements.define('compare-products-modal', CompareProductsModal);
/******/ })()
;